import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  Row,
  Col,
  Form,
  Upload,
  Breadcrumb,
  Select,
  Space,
  Input,
  Spin,
  Radio,
  Button,
  AutoComplete,
  Collapse,
  Tooltip,
  Checkbox,
  message,
  Layout,
  Modal,
} from "antd";
import {
  DeleteOutlined,
  MinusSquareFilled,
  PlusSquareFilled,
  PercentageOutlined,
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  SaveOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import verifybtn from "../../image/verifybtn.png";

import unVerify from "../../image/unverify.png";
import InputField from "../../common/htmlComponents/InputField";
import EmailField from "../../common/htmlComponents/EmailField";
import TextAreaField from "../../common/htmlComponents/TextAreaField";
import { ReactComponent as User } from "../../image/User.svg";
import { ReactComponent as Vector } from "../../image/Vector.svg";
import { ReactComponent as AddressLine } from "../../image/AddressLine.svg";
import { ReactComponent as Email } from "../../image/Email.svg";
import { ReactComponent as Name } from "../../image/Name.svg";
import { ReactComponent as City } from "../../image/City.svg";
import { ReactComponent as IdcardOutlined } from "../../image/IdcardOutlined.svg";
import { ReactComponent as ZipCode } from "../../image/ZipCode.svg";
import { ReactComponent as Website } from "../../image/Website.svg";
import { ReactComponent as About } from "../../image/About.svg";
import { ReactComponent as FileImageOutlined } from "../../image/FileImageOutlined.svg";
import { ReactComponent as FileAlt } from "../../image/FileAlt.svg";
import { authUserData } from "../../utils/Helper";
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
  WarningNotificationMsg,
} from "../../utils/Notifications";
//import VendorDocumentGrid from "./VendorDocumentGrid";
import VendorDocumentGrid from "../../feature/vendor/VendorDocumentGrid";
import { debounce } from "lodash";
// import KeyPersonVendor from "../../KeyPersonVendor";
import KeyPersonVendor from "../../feature/vendor/KeyPersonVendor";
// import InquiryValueVendor from "../../InquiryValueVendor";
import InquiryValueVendor from "../../feature/vendor/InquiryValueVendor";
// import BankDetailsVendor from "../../BankDetailsVendor";
import BankDetailsVendor from "../../feature/vendor/BankDetailsVendor";
// import AssignSiteVendor from "../../AssignSiteVendor";
import AssignSiteVendor from "../../feature/vendor/AssignSiteVendor";
// import PaymentVendor from "../../PaymentVendor";
import PaymentVendor from "../../feature/vendor/PaymentVendor";
// import VendorDocumentField from "../../VendorDocumentField";
import VendorDocumentField from "../../feature/vendor/VendorDocumentField";
// import VendorLogoUpload from "../../VendorLogoUpload";
import VendorLogoUpload from "../../feature/vendor/VendorLogoUpload";
// import CommunicationMatrixVendor from "../../CommunicationMatrixVendor";
import CommunicationMatrixVendor from "../../feature/vendor/CommunicationMatrixVendor";
// import PaymentPersonReleasedField from "../../PaymentPersonReleasedField";
import PaymentPersonReleasedField from "../../feature/vendor/PaymentPersonReleasedField";
// import AssignCityVendor from "../../AssignCityVendor";

// import AssignCityVendorStep from "./AssignCityVendorStep";
import StepInquiryValueVendor from "./StepInquiryValueVendor";
import { Content } from "antd/lib/layout/layout";
import StepSider from "./StepSider";
import SupplierBillingDetails from "../../feature/vendor/SupplierBillingDetails";
import VerifyOtpModal from "../VerifyOtpModel";
import PhoneOtpVerify from "../PhoneOtpVerify";
import SupplierBillingDetailsStep from "./SupplierBillingDetailsStep";
import VendorDocumentFieldStep from "./VendorDocumentFieldStep";

const { Option } = Select;

const AddVendorOnboardingStep = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const VendorId = id ? id : null;
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const userId = authUserData()?.user_id ? authUserData()?.user_id : null;
  const formRef = useRef();
  const initialDocument = { vendor_company: null, document_name: null };
  const { Panel } = Collapse;
  const [stateDropdownOptions, setStateDropdownOptions] = useState([]);
  const [verificationResultGST, setVerificationResultGST] = useState(null);
  const [verificationResultPancard, setVerificationResultPancard] =
    useState(null);
  const [verificationResultContact, setVerificationResultContact] =
    useState(null);
  const [verificationResultEmail, setVerificationResultEmail] = useState(null);
  const [verifyEmailButtonView, setVerifyEmailButtonView] = useState(true);
  const [verificationResultAdhaar, setVerificationResultAadhaar] =
    useState(null);
  const [btnLoadingAdhaar, setBtnLoadingAdhaar] = useState(false);
  const [verifyAdhaar, setVerifyAdhaar] = useState(false);
  const [verifyPhoneButtonView, setVerifyPhoneButtonView] = useState(true);
  const [OTP, setOTP] = useState(null);
  const [OTPPhone, setOTPPhone] = useState(null);

  const initialState = {
    vendor_registered_name: null,
    person_name: null,
    designation: null,
    // address_line_1: null,
    // city: null,
    // state: null,
    // pincode: null,
    website: null,
    no_of_employees: null,
    company_pan: null,
    gst_no: null,
    email: null,
    phone: null,
    gst_no_verified: false,
    udyam_aadhaar_no_verified: false,
    phone_verified: false,
    email_verified: false,
    lut_number: null,
    msme: false,
    msme_number: null,
    vendor_trade_name: null,
    // registered_business_address: null,
    // trading_address: null,

    registered_business_address_building: null,
    registered_business_address_area: null,
    registered_business_address_landmark: null,
    registered_business_address_state: null,
    registered_business_address_city: null,
    registered_business_address_pincode: null,
    trading_address_building: null,
    trading_address_area: null,
    trading_address_landmark: null,
    trading_address_state: null,
    trading_address_city: null,
    trading_address_pincode: null,
    same_as_registered_business_address: false,

    vendor_inquiry_value: [
      {
        company: CompanyId,
        category_tree: 1,
        company_material_type: [],
        minimum_inquiry_value: null,
        maximum_inquiry_value: null,
        city: [],
      },
    ],
    assign_city_to_vendor: [
      {
        company: CompanyId,
        category_tree: 1,
        material_type: null,
        // state: null,
        city: [],
        // gst_number: null,
      },
    ],

    // user: {
    //   company: CompanyId,
    //   vendor_company_code: null,
    // },
    vendor_company_code: {
      company: CompanyId,
      vendor_code_by_company: null,
    },
  };

  const [state, setState] = useState(initialState);
  const [stateDropdownOptionsShipping, setShippingState] = useState([]);
  const [pincodeListBillingRegistered, setPincodeListBillingRegistered] =
    useState([]);
  const [searchValueBilling, setSearchValueBilling] = useState("");
  const [pincodeListShipping, setPincodeListShipping] = useState([]);
  const [searchValueShipping, setSearchValueShipping] = useState("");
  const [documentState, setDocumentState] = useState(initialDocument);
  const [isGstNoReadOnly, setIsGstNoReadOnly] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoadingPhone, setBtnLoadingPhone] = useState(false);
  const [btnLoadingEmail, setBtnLoadingEmail] = useState(false);
  const [btnLoadingPan, setBtnLoadingPan] = useState(false);
  const [apiLoading, setapiloading] = useState(false);
  const [pincodeList, setPincodeList] = useState([]);
  const [categoryTree, setCategoryTree] = useState([]);
  const [categoryTreeCity, setCategoryTreeCity] = useState([]);
  const [size, setSize] = useState(null);
  const [sizeOne, setSizeOne] = useState(null);
  const [uploadFile, setUploadFile] = useState("");
  const [fileLink, setFileLink] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [uploadFileOne, setUploadFileOne] = useState("");
  const [fileLinkOne, setFileLinkOne] = useState(null);
  const [fileNameOne, setFileNameOne] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [addedVendorId, setAddedVendorId] = useState(null);
  const [gstVendorId, setgstVendorId] = useState(null);
  const [vendorDocumentList, setVendorDocumentList] = useState(null);
  const [refreshGrid, setRefreshGrid] = useState(false);
  const [vendorDocumentId, setVendorDocumentId] = useState(null);
  const [siteEmployee, setSiteEmployee] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [postGeneratedVendorId, setPostGeneratedVendorId] = useState(null);
  const [keyPersonId, setKeyPersonId] = useState(null);
  const [paymentReleasedId, setPaymentReleasedId] = useState(null);
  const [communicationMatrixId, setCommunicationMatrixId] = useState(null);
  const [bankDetailId, setBankDetailId] = useState(null);
  const [assignSiteId, setAssignSiteId] = useState(null);
  const [supplierBillingId, SetSupplierBillingId] = useState(null);
  const [paymentTermsId, setPaymentTermsId] = useState(null);
  const [inquiryValueId, setInquiryValueId] = useState(null);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [materialType, setMaterialType] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [gstValue, setGstValue] = useState(null);
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [btnLoadingVerifyGst, setBtnLoadingVerifyGst] = useState(false);
  const [verifyGstDisable, setVerifyDisable] = useState(true);
  const [verifyGstButtonView, setVerifyGstButtonView] = useState(true);
  const [verifyAdhaarButtonView, setVerifyAdhaarButtonView] = useState(true);

  const url = state.msme_document;
  // const urlone = state.document_url;
  const [showKeyPersonCollapse, setShowKeyPersonCollapse] = useState(false);
  const [showVendorCommunicationCollapse, setShowVendorCommunicationCollapse] =
    useState(false);
  const [showPaymentPersonReleasedField, setShowPaymentPersonReleasedField] =
    useState(false);
  const [showVendorBillingDetails, setShowVendorBillingDetails] =
    useState(false);
  const [showBankDetailsCollapse, setShowBankDetailsCollapse] = useState(false);
  const [showAssignSiteCollapse, setShowAssignSiteCollapse] = useState(false);
  const [showPaymentCollapse, setShowPaymentCollapse] = useState(false);
  const [showPaymentWithoutCollapse, setShowBankDetailsWithoutCollapse] =
    useState(false);
  const [identifyProfileUrl, setIdentifyProfileUrl] = useState(null);
  const [uploadFileProfilePic, setUploadFileProfilePic] = useState("");
  const [fileList, setFileList] = useState([]);
  const [disabledOptions, setDisabledOptions] = useState([]);
  const [disabledOptionsCity, setDisabledOptionsCity] = useState([]);
  const [cityDropdownOptionsShipping, setCityShipping] = useState([]);
  const [venId, setVenId] = useState(null);
  const [cityDropdownOptionsAddVendor, setCityDropdownOptionsAddVendor] =
    useState([]);
  const [cityDropdownOptions, setCityDropdownOptions] = useState([]);

  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(0);

  const [minutesPhone, setMinutesPhone] = useState(1);
  const [secondsPhone, setSecondsPhone] = useState(0);

  const [tradingCityDropdownOptions, setTradingCityDropdownOptions] = useState(
    []
  );
  const [errorMsg, setErrorMsg] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenPhone, setIsModalOpenPhone] = useState(false);
  const [modalKey, setModalKey] = useState(false);
  const [reload, setReload] = useState(false);
  const [zoneList, setZoneList] = useState([]);
  const [pincodeId, setPincodeId] = useState(null);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setOTP(null);
    setSeconds(30);
    setMinutes(1);
    setBtnLoadingEmail(false);
  };
  const showModalPhone = () => {
    setIsModalOpenPhone(true);
  };
  const handleOkPhone = () => {
    setIsModalOpenPhone(false);
  };
  const handleCancelPhone = () => {
    setIsModalOpenPhone(false);
    setOTPPhone(null);
    setSecondsPhone(30);
    setMinutesPhone(1);
    setBtnLoadingPhone(false);
  };
  const handleCloneInputChange = (field, e, index) => {
    let newPersonArr = state.suppliers_billing_details;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, suppliers_billing_details: newPersonArr });
  };
  const handleAdhaarNumberVerify = async () => {
    setVerifyAdhaar(true);
    setVerifyAdhaarButtonView(true);
    try {
      const adhaarNumber = state?.udyam_aadhaar_no;

      if (adhaarNumber) {
        setBtnLoadingAdhaar(true);
        const response = await getRequest(
          `/doc-verification/udhyam/?udhyam_no=${adhaarNumber}`
        );
        console.log(response, "responseddd");
        if (response.data.results.data) {
          SuccessNotificationMsg("Udyam Number verified successfully");
          setVerificationResultAadhaar("success");
          setBtnLoadingAdhaar(false);
          setVerifyAdhaarButtonView(false);
        } else {
          // Handle case when GST number is not valid

          setBtnLoadingAdhaar(false);
          // setVerificationResultAadhaar('failure');
          setVerifyAdhaarButtonView(true);
        }
      }
    } catch (error) {
      ErrorNotificationMsg(t("Error in verifying number"));
      setBtnLoadingAdhaar(false);
      // setVerificationResultAadhaar('failure');
      setVerifyAdhaarButtonView(true);
    }
  };
  const handleGstNumberVerify = async () => {
    setVerifyDisable(true);
    setVerifyGstButtonView(true);
    try {
      setBtnLoadingVerifyGst(true);
      const gst = state?.gst_no;

      // const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      // if (!gst || !gstRegex.test(gst)) {
      //   ErrorNotificationMsg(t("Invalid GST No."));
      //   setVerificationResultGST('error');
      //   return;
      // }

      //setBtnLoading(true);
      const response = await getRequest(`doc-verification/gst/?gst_no=${gst}`);
      console.log(response, "responseddd");
      if (response.data.results.data) {
        SuccessNotificationMsg("GST verified successfully");
        setVerificationStatus("success");
        setBtnLoadingVerifyGst(false);
        setVerifyGstButtonView(false);
      } else {
        // Handle case when GST number is not valid
        ErrorNotificationMsg(t("Invalid GST No."));
        // setVerificationStatus("failure");
        setBtnLoadingVerifyGst(false);
        setVerifyDisable(false);
        setVerifyGstButtonView(true);
      }
    } catch (error) {
      ErrorNotificationMsg(t("Error in verifying GST number"));
      // setVerificationStatus("failure");
      setVerifyDisable(false);
      setBtnLoadingVerifyGst(false);
      setVerifyGstButtonView(true);
    }
  };

  const [sameAsRegisteredBusinessAddress, setSameAsRegisteredBusinessAddress] =
    useState(false);

  let filename = "";
  let filenameone = "";
  try {
    if (fileLink) {
      filename = url.split("/").pop();
    }
  } catch (e) {
    filename = "";
  }
  const onChange = (key) => {
    console.log(key);
  };
  // try {
  //   if (fileLinkOne) {
  //     filenameone = urlone.split("/").pop();
  //   }
  // } catch (e) {
  //   filenameone = "";
  // }
  useEffect(() => {
    const getVendorOnboarding = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest(
          `vendor/${VendorId}/?company_id=${CompanyId}`
          //  `vendor/${VendorId}/?vendor_id=${VendorId}/?company_id=${CompanyId}`
        );
        // const apiResponse = await getRequest(
        //   // `vendor/${VendorId}/get-vendor-payment-terms/${CompanyId}/`
        // );
        setVenId(apiResponse.data.data.id);
        // setShowBankDetailsCollapse(true);
        setShowKeyPersonCollapse(true);
        // setShowVendorCommunicationCollapse(true);
        if (apiResponse.data.success) {
          const {
            unique_code,
            id,
            company_payment_terms,
            keypersons,
            bankdetails,
            suppliers_billing_details,
            assign_city,
            inquiry_value,
            vendor_company_code,
            ...filteredResponse
          } = apiResponse.data.data;
          if (
            apiResponse.data.data.trading_address_state !== null &&
            apiResponse.data.data.trading_address_state !== undefined &&
            apiResponse.data.data.trading_address_state !== ""
          ) {
            //getCityByStateTrading(apiResponse.data.data.trading_address_state);
          }
          if (
            apiResponse.data.data.registered_business_address_state !== null &&
            apiResponse.data.data.registered_business_address_state !==
              undefined &&
            apiResponse.data.data.registered_business_address_state !== ""
          ) {
            // getCityByStateForShipping(
            //   apiResponse.data.data.registered_business_address_state
            // );
          }

          // const firstPaymentTerm = apiResponse.data.data.vendor_company_data[0];
          // const companyPaymentTermsValues = [

          //     days_to_pay: firstPaymentTerm.days_to_pay,
          //     when_to_pay: firstPaymentTerm.when_to_pay,
          //     when_to_calculate: firstPaymentTerm.when_to_calculate,
          //     advance: firstPaymentTerm.advance,

          // ];
          const inquiryValueFromApi = apiResponse.data.data.inquiry_value;
          const categoryTreeMaterials =
            inquiryValueFromApi && inquiryValueFromApi.length > 0
              ? inquiryValueFromApi[0].category_tree_materials
              : [];

          setState({
            ...filteredResponse,
            vendor_inquiry_value: categoryTreeMaterials.map((inquiry) => {
              const {
                vendor,
                vendor_name,
                category_tree_name,
                category_tree,
                company_name,
                company,
                city,
                city_name,
                company_material_type,
                ...rest
              } = inquiry;

              return {
                company:
                  inquiryValueFromApi && inquiryValueFromApi.length > 0
                    ? inquiryValueFromApi[0].company
                    : CompanyId,
                category_tree: category_tree,
                company_material_type: company_material_type.map(
                  (material) => material.id
                ),
                city: city.map((material) => material.id),
                ...rest,
              };
            }),
            vendor_company_code: {
              id: apiResponse.data.data.vendor_company_code[0].id,
              company: CompanyId,
              vendor_code_by_company:
                apiResponse.data.data.vendor_company_code[0]
                  .vendor_code_by_company,
            },
            //   {
            //     const {
            //       // id,
            //       vendor,
            //       vendor_name,
            //       category_tree_name,
            //       company_name,
            //       company,
            //       ...rest
            //     } = apiResponse.data.data.vendor_company_code[0];
            //     // Adding the 'company' attribute with value 4
            //     return {
            //       company: CompanyId,
            //       id:
            //       ...rest,
            //     };
            //   }
            // ),
            // vendor_company_code:
            //   apiResponse.data.data.vendor_company_code_data[0],
          });

          const newItem = categoryTreeMaterials.map((item) => {
            return item.category_tree;
          });
          setDisabledOptions(newItem);

          setPostGeneratedVendorId(apiResponse.data.data.id);
          setFileLink(apiResponse.data.data.msme_document);
          if (apiResponse.data.data.keypersons.length > 0) {
            const keyPersonId =
              apiResponse.data.data.keypersons[0].id !== null
                ? apiResponse.data.data.keypersons[0].id
                : null;

            setKeyPersonId(keyPersonId);
            setShowVendorBillingDetails(keyPersonId !== null);
          } else {
            setKeyPersonId(null);
            setShowVendorBillingDetails(false);
          }
          if (apiResponse.data.data.payment_released.length > 0) {
            const paymentReleasedId =
              apiResponse.data.data.payment_released[0].id !== null
                ? apiResponse.data.data.payment_released[0].id
                : null;
            setPaymentReleasedId(paymentReleasedId);
          } else {
            setPaymentReleasedId(null);
          }

          // Set BankDetailId
          const bankDetailId =
            apiResponse.data.data.bankdetails[0].id !== null
              ? apiResponse.data.data.bankdetails[0].id
              : null;
          setBankDetailId(bankDetailId);

          const supplierBillingId =
            apiResponse.data.data.suppliers_billing_details[0].id !== null
              ? apiResponse.data.data.suppliers_billing_details[0].id
              : null;
          SetSupplierBillingId(supplierBillingId);
          setShowBankDetailsCollapse(supplierBillingId !== null);

          const communicationMatrixId =
            apiResponse.data.data.vendor_communication_matrix_data[0].id !==
            null
              ? apiResponse.data.data.vendor_communication_matrix_data[0].id
              : null;
          setCommunicationMatrixId(communicationMatrixId);

          // Set AssignSiteId
          // const assignSiteId =
          //   apiResponse.data.data.assgin_site[0].id !== null
          //     ? apiResponse.data.data.assgin_site[0].id
          //     : null;
          // setAssignSiteId(assignSiteId);

          // Set InquiryValueId
          // const inquiryValueId =
          //   apiResponse.data.data.inquiry_value[0].id !== null
          //     ? apiResponse.data.data.inquiry_value[0].id
          //     : null;
          // setInquiryValueId(inquiryValueId);

          // Set PaymentTermsId
          const paymentTermsId =
            apiResponse.data.data.company_payment_terms[0].id !== null
              ? apiResponse.data.data.company_payment_terms[0].id
              : null;
          setPaymentTermsId(paymentTermsId);
          setShowPaymentPersonReleasedField(paymentTermsId !== null);
          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
            lut_number: apiResponse.data.data.lut_number,
            vendor_trade_name: apiResponse.data.data.vendor_trade_name,
            vendor_registered_name:
              apiResponse.data.data.vendor_registered_name,
            // registered_business_address:
            //   apiResponse.data.data.registered_business_address,
            // trading_address: apiResponse.data.data.trading_address,

            registered_business_address_building:
              apiResponse?.data?.data?.registered_business_address_building,
            registered_business_address_area:
              apiResponse?.data?.data?.registered_business_address_area,
            registered_business_address_landmark:
              apiResponse?.data?.data?.registered_business_address_landmark,
            registered_business_address_state:
              apiResponse?.data?.data?.registered_business_address_state,
            registered_business_address_city:
              apiResponse?.data?.data?.registered_business_address_city,
            registered_business_address_pincode:
              apiResponse?.data?.data
                ?.registered_business_address_pincode_number,
            trading_address_building:
              apiResponse?.data?.data?.trading_address_building,
            trading_address_area: apiResponse?.data?.data?.trading_address_area,
            trading_address_landmark:
              apiResponse?.data?.data?.trading_address_landmark,
            trading_address_state:
              apiResponse?.data?.data?.trading_address_state,
            trading_address_city: apiResponse?.data?.data?.trading_address_city,
            trading_address_pincode:
              apiResponse?.data?.data?.trading_address_pincode_number,

            pincode: apiResponse.data.data.pincode_name,
            phone: String(apiResponse.data.data.phone),
            msme: apiResponse.data.data.msme,
            city: apiResponse.data.data.city_name,
            // category: apiResponse.data.data.category.map(function (el) {
            //   return el.id;
            // }),
            vendor_inquiry_value: categoryTreeMaterials.map((inquiry) => {
              const {
                vendor,
                vendor_name,
                category_tree_name,
                city_name,
                city,
                company_material_type_name,
                ...rest
              } = inquiry;
              return {
                city_name,
                city,
                ...rest,
              };
            }),
            vendor_code_by_company:
              apiResponse.data.data.vendor_company_code[0]
                .vendor_code_by_company,

            // assign_city_to_vendor: apiResponse.data.data.assign_city.map(
            //   (inquiry) => {
            //     const {
            //       // id,
            //       vendor,
            //       vendor_name,
            //       city_name,
            //       company_name,
            //       material_type_name,
            //       ...rest
            //     } = inquiry;

            //     return rest;
            //   }
            // ),
            // company_payment_terms: [companyPaymentTermsValues],
            // company_payment_terms: [...companyPaymentTermsValues],
            // company_payment_terms: companyPaymentTermsValues,
          });

          const url = apiResponse.data.data.vendor_logo;
          setIdentifyProfileUrl(apiResponse.data.data.vendor_logo);
          if (url !== null) {
            setFileList([
              {
                // uid: '-1',
                // name: 'image.png',
                // status: 'done',
                url: url,
              },
            ]);
          }
          setSelectedOption(apiResponse.data.data.msme);
          const modifiedInquiry = categoryTreeMaterials.map((inquiryDetail) => {
            const { id, vendor, vendor_name, ...rest } = inquiryDetail;
            return rest;
          });
          setWeightSizeInquiryFieldValue(modifiedInquiry);

          const modifiedInquiryCity = apiResponse.data.data.assign_city.map(
            (inquiryDetail) => {
              const { id, vendor, vendor_name, ...rest } = inquiryDetail;
              return rest;
            }
          );
          setWeightSizeInquiryFieldValueCity(modifiedInquiryCity);

          const modifiedInquirySuppliers =
            apiResponse.data.data.suppliers_billing_details.map(
              (inquiryDetail) => {
                const { id, vendor, vendor_name, ...rest } = inquiryDetail;
                return rest;
              }
            );
          setWeightSizeInquiryFieldValueSuppliers(modifiedInquirySuppliers);

          if (apiResponse?.data?.data?.gst_no_verified === true) {
            setVerificationStatus("success");
            setVerifyGstButtonView(false);
          } else {
            setVerificationStatus(null);
            setVerifyGstButtonView(true);
          }

          if (apiResponse?.data?.data?.udyam_aadhaar_no_verified === true) {
            setVerificationResultAadhaar("success");
            setVerifyAdhaarButtonView(false);
          } else {
            setVerificationResultAadhaar(null);
            setVerifyAdhaarButtonView(true);
          }
          if (apiResponse?.data?.data?.email_verified === true) {
            setVerificationResultEmail("success");
            setVerifyEmailButtonView(false);
          } else {
            setVerificationResultEmail(null);
            setVerifyEmailButtonView(true);
          }

          if (apiResponse?.data?.data?.phone_verified === true) {
            setVerificationResultContact("success");
            setVerifyPhoneButtonView(false);
          } else {
            setVerificationResultContact(null);
            setVerifyPhoneButtonView(true);
          }

          // getCityByStateForShipping(apiResponse.data.data.state);
          // setShowAssignSiteCollapse(true);

          // setShowPaymentCollapse(true);
          // setWeightSizeBankFieldValue(apiResponse.data.data.bankdetails);

          if (
            apiResponse.data.data?.registered_business_address_building ===
              apiResponse.data.data?.trading_address_building &&
            apiResponse.data.data?.registered_business_address_area ===
              apiResponse.data.data?.trading_address_area &&
            apiResponse.data.data?.registered_business_address_landmark ===
              apiResponse.data.data?.trading_address_landmark &&
            apiResponse.data.data?.registered_business_address_state ===
              apiResponse.data.data?.trading_address_state &&
            apiResponse.data.data?.registered_business_address_city ===
              apiResponse.data.data?.registered_business_address_city &&
            apiResponse.data.data?.registered_business_address_pincode ===
              apiResponse.data.data?.trading_address_pincode
          ) {
            setSameAsRegisteredBusinessAddress(true);
          }
        } else {
          ErrorNotificationMsg(t("error_in_list_delivery_address"));
          setSameAsRegisteredBusinessAddress(false);
        }
        if (VendorId !== null) {
          setIsGstNoReadOnly(true);
        } else {
          ErrorNotificationMsg(t("err_getSubscription"));
        }
        setFormSubmitted(true);
        // setAddedVendorId(VendorId);
        // setAddedVendorId(
        //   apiResponse.data.data.company_payment_terms.length > 0
        //     ? apiResponse.data.data.company_payment_terms[0].id
        //     : null // or some default value if there are no elements
        // );
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    if (VendorId !== null) {
      // getPaymentTerms();
      getVendorOnboarding();
      // getPaymentTerms();
    }
    // getPaymentTerms();
    // getPincode();
    getCategoryTree();
    // getSite();
    getMaterialTypeByCategory();
    // getStateShipping();
  }, [VendorId, CompanyId, t]);
  const [pincodeListBilling, setPincodeListBilling] = useState([]);
  const searchINBilling = async (value) => {
    // http://127.0.0.1:8000/pincode/?search_pincode_number=38001
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    if (apiResponse.data.results.success) {
      setPincodeListBilling(apiResponse.data.results.data);
    }
  };
  const onSearchBilling = async (value) => {
    setSearchValueBilling(value);
    value.length >= 4
      ? searchINBilling(!value ? null : value)
      : setPincodeListBilling([]);
  };
  // const getStateShipping = async () => {
  //   await getRequest("state/?no_pagination=true").then((response) => {
  //     setShippingState(response.data.data);
  //     setStateDropdownOptions(response.data.data);
  //   });
  // };
  // const getCityByStateForShipping = async (StateId) => {
  //   await getRequest(`city/${StateId}/`).then((response) => {
  //     setCityShipping(response.data.data);
  //   });
  // };

  const handleStateChangeRegistered = (values) => {
    console.log(values, "Valuessss");
    setState({
      ...state,
      registered_business_address_state: values,
      registered_business_address_city: null,
    });
    setCityDropdownOptions([]);
    formRef.current.setFieldsValue({
      ...state,
      registered_business_address_state: values,
      registered_business_address_city: "",
      registered_business_address_pincode:
        state?.registered_business_address_pincode_number,
      trading_address_pincode: state.trading_address_pincode_number,
    });

    // if (values !== null && values !== undefined) {
    //   //getCityByStateForShipping(values); //1 0
    //   getCityByState(values);
    // }
  };

  const handleStateChangeTrading = (values) => {
    console.log(values, "Valuessss");
    setState({
      ...state,
      trading_address_state: values,
      trading_address_city: null,
    });
    setTradingCityDropdownOptions([]);
    formRef.current.setFieldsValue({
      ...state,
      trading_address_state: values,
      trading_address_city: "",
      trading_address_pincode: state.trading_address_pincode_number,
      registered_business_address_pincode:
        state?.registered_business_address_pincode_number,
    });

    // if (values !== null && values !== undefined) {
    //   // getCityByStateForShipping(values); //1 0
    //   getCityByStateTrading(values);
    // }
  };

  // const getCityByState = async (StateId) => {
  //   await getRequest(`city/${StateId}/`).then((response) => {
  //     setCityDropdownOptions(response.data.data);
  //     setCityDropdownOptionsAddVendor(response.data.data);
  //     console.log("piiiu", response.data.data);
  //   });
  // };

  // const getCityByStateTrading = async (StateId) => {
  //   await getRequest(`city/${StateId}/`).then((response) => {
  //     setTradingCityDropdownOptions(response.data.data);
  //     console.log("piiiu", response.data.data);
  //   });
  // };

  // const handleStateChangeShipping = (values) => {
  //   console.log(values, "Valuessss");
  //   setState({ ...state, state: values, city: null }); // Updating the state with the new category_tree value
  //   setCityShipping([]);
  //   // formRef.current.setFieldsValue({
  //   //   ...state,
  //   //   state: values,
  //   //   city: "",
  //   // });
  //   // Fetch material types based on the selected category
  //   if (values !== null && values !== undefined) {
  //     getCityByStateForShipping(values); //1 0
  //   }
  // };

  useEffect(() => {
    const getVendorDocument = async () => {
      setapiloading(true);
      try {
        let filenameone1;
        const apiResponse = await getRequest(
          "vendor-document/" + vendorDocumentId
        );

        if (apiResponse.data.success) {
          setDocumentState({
            ...apiResponse.data.data,
          });
          // setFileLinkOne(apiResponse.data.data.document_url);
          try {
            filenameone1 = apiResponse.data.data.document_url.split("/").pop();
            setFileNameOne(filenameone1);
          } catch (e) {
            filenameone1 = "";
            setFileNameOne(null);
          }
          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
          });
        } else {
          ErrorNotificationMsg(t("err_getSubscription"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    if (vendorDocumentId !== null) {
      getVendorDocument();
    }
  }, [vendorDocumentId, t]);

  // const getPincode = async (data) => {
  //   await getRequest("pincode/", data).then((response) => {
  //     setPincodeList(response.data.results.data);
  //   });
  // };

  const getCategoryTree = async (data) => {
    await getRequest("category-tree/?no_pagination=True", data).then(
      (response) => {
        setCategoryTree(response.data.data);
        setCategoryTreeCity(response.data.data);
      }
    );
  };

  console.log("categoryTree ", categoryTree);
  // const getSite = async (data) => {
  //   // await getRequest("employee/site-by-company/?no_pagination=True", data).then(

  //   await getRequest(`city/${12}/`).then((response) => {
  //     console.log("response 91", response);
  //     setSiteList(response.data.data);

  //     // setSiteEmployee(response.data.results.data);
  //     // setSiteList(response.data.results.data);
  //   });
  // };
  const getMaterialTypeByCategory = async (categoryId) => {
    try {
      const materialTypeResponse = await getRequest(
        `material-type/?category_tree_id=${1}`
      );

      setMaterialType(materialTypeResponse.data.results.data);

      // Reset material_type field in the state for the selected index
      // let newFeatureArr = state.assgin_site;
      // newFeatureArr[index].material_type = null;
      // setState({ ...state, assgin_site: newFeatureArr });
      // formRef.current.setFieldsValue({
      //   [`material_type${index}`]: null,
      // });
    } catch (error) {
      console.error("Error fetching material types:", error);
    }
  };
  const getGSTNumberVerify = useCallback(
    debounce(async (value, onTypeGst) => {
      onTypeGst(value);

      try {
        if (value !== "" && VendorId === null) {
          setapiloading(true);
          setGstValue(value);

          // Make the API call with the provided GST number
          const apiResponse = await getRequest(
            `get-vendor-by-gst/?gst_no=${value}`
          );

          if (apiResponse.data.results.data.length > 0) {
            // Valid GST number found
            console.log("GST number is valid.");
            // You can further handle or notify user about the validity if needed
          } else {
            // No vendor found for the GST number, indicating it is not valid
            console.log("GST number is not valid or no vendor found.");
            // You can handle or notify user about the invalid GST number here
          }

          setapiloading(false);
        }
      } catch (error) {
        setapiloading(false);
        console.error("Error checking GST number:", error);
        // Handle error scenarios here
      }
    }, 1200),
    []
  );

  // const getSite = async (data) => {
  //   await getRequest("employee/site-by-company/?no_pagination=True", data).then(
  //     (response) => {
  //       setSiteList(response.data.results.data);
  //     }
  //   );
  //   // setSiteList([]);
  // };

  const phoneValidLength = state.phone;

  const validatePhoneNumber = () => {
    if (
      (phoneValidLength && phoneValidLength.length < 12) ||
      phoneValidLength === null ||
      phoneValidLength === ""
    ) {
      return Promise.reject(new Error(t("please_enter_valid_phone")));
    }

    return Promise.resolve();
  };
  // const handleCategoryChange = (index, value) => {
  //   const updatedAssignCity = [...state.assign_city_to_vendor];
  //   updatedAssignCity[index].category_tree = value;
  //   setState({ ...state, assign_city_to_vendor: updatedAssignCity });
  // };

  const handleCategoryChange = (field, value, index) => {
    let newFeatureArr = state.assign_city_to_vendor;
    const newValue = value === undefined ? null : value;
    if (newFeatureArr[index]) {
      newFeatureArr[index][field] = newValue;
      setState({ ...state, assign_city_to_vendor: newFeatureArr });
    }
  };
  const handleStateChange = (field, index, value) => {
    console.log(field, value, index);
    let updatedAssignCity = [...state.assign_city_to_vendor];
    updatedAssignCity[index].state = value;
    updatedAssignCity[index].city = null;
    setState({ ...state, assign_city_to_vendor: updatedAssignCity });
    // formRef.current.setFieldsValue({
    //   ...state,
    //   assign_city_to_vendor: updatedAssignCity,
    // });
    // if (value !== null && value !== undefined) {
    //   getCityByState(value); //1 0
    // }
  };

  const handleMaterialChange = (index, value) => {
    const updatedAssignCity = [...state.assign_city_to_vendor];
    updatedAssignCity[index].material_type = value;
    setState({ ...state, assign_city_to_vendor: updatedAssignCity });
  };

  const handleMaterialChangeForInquiry = (index, value) => {
    const updatedAssignCity = [...state.vendor_inquiry_value];
    updatedAssignCity[index].material_type = value;
    setState({ ...state, vendor_inquiry_value: updatedAssignCity });
  };

  // const handleCityChange = (field, index, value) => {
  //   const updatedAssignCity = [...state.assign_city_to_vendor];
  //   updatedAssignCity[index].city = value;
  //   setState({ ...state, assign_city_to_vendor: updatedAssignCity });
  // };
  const handleCityChangeSite = (field, index, value) => {
    const updatedAssignCity = [...state.assign_city_to_vendor];
    updatedAssignCity[index].city = value;
    setState({ ...state, assign_city_to_vendor: updatedAssignCity });
  };

  const handleGstInputChangeCity = (index, value) => {
    const updatedAssignCity = [...state.assign_city_to_vendor];
    updatedAssignCity[index].gst_number = value;
    setState({ ...state, assign_city_to_vendor: updatedAssignCity });
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    // value = value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
    setState({ ...state, [name]: value !== "" ? value : null });
  };
  const handleInputChangeEmail = (e) => {
    let { name, value } = e.target;
    setVerifyEmailButtonView(true);
    setVerificationResultEmail("");
    // value = value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
    // setState({ ...state, email: value !== "" ? value : null });
    setState((prevState) => ({
      ...prevState,
      email: value !== "" ? value : null,
      email_verified: false,
    }));
  };
  // const handleInputAdhaarChange = (e) => {
  //   let { name, value } = e.target;
  //   setVerificationResultAadhaar("");
  //   setVerifyAdhaar(true);
  //   setVerifyAdhaarButtonView(true);
  //   // value = value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  //   setState({ ...state,
  //              udyam_aadhaar_no: value !== "" ? value : null,
  //              udyam_aadhaar_no_verified: false
  //              });
  // };

  const handleInputAdhaarChange = (e) => {
    let { name, value } = e.target;
    setVerificationResultAadhaar("");
    setVerifyAdhaar(true);
    setVerifyAdhaarButtonView(true);
    // value = value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
    setState({
      ...state,
      udyam_aadhaar_no: value !== "" ? value : null,
      udyam_aadhaar_no_verified: false,
    });
  };

  const handleInputChangePancard = (e) => {
    let { name, value } = e.target;
    // value = value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
    setState({ ...state, [name]: value !== "" ? value : null });
    setVerificationResultPancard("");
  };
  const handleInputChangeVendorCode = (e) => {
    let { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      vendor_company_code: {
        ...prevState.vendor_company_code,
        vendor_code_by_company: value !== "" ? value : null,
      },
    }));
  };

  let flag = false;

  // const debouncedFetchData = useCallback(
  //   debounce(async (value, onTypeGst) => {
  //     onTypeGst(value);

  //     try {
  //       // Update the state with the entered GST number

  //       if (value !== "" && VendorId === null) {
  //         setapiloading(true);
  //         setGstValue(value);
  //         // Make the API call with the provided GST number
  //         const apiResponse = await getRequest(
  //           `get-vendor-by-gst/?gst_no=${value}`
  //         );
  //         // if (apiResponse.status && apiResponse.data.results.data.length > 0) {

  //         if (!flag) {
  //           if (apiResponse.data.results.data.length > 0) {
  //             const {
  //               pincode_name,
  //               unique_code,
  //               // vendor_company_data,
  //               id,
  //               company_payment_terms,
  //               keypersons,
  //               bankdetails,
  //               assgin_city,
  //               inquiry_value,
  //               vendor_company_code_data,
  //               ...filteredResponse
  //             } = apiResponse.data.results.data[0];

  //             setapiloading(false);
  //             setgstVendorId(apiResponse.data.results.data[0].id);
  //             setPostGeneratedVendorId(null); //When I get GST ID make Vendor ID Null

  //             if (
  //               apiResponse.data.results.data[0].trading_address_state !==
  //               null &&
  //               apiResponse.data.results.data[0].trading_address_state !==
  //               undefined &&
  //               apiResponse.data.results.data[0].trading_address_state !== ""
  //             ) {
  //               // getCityByStateTrading(
  //               //   apiResponse.data.results.data[0].trading_address_state
  //               // );
  //             }
  //             if (
  //               apiResponse.data.results.data[0]
  //                 .registered_business_address_state !== null &&
  //               apiResponse.data.results.data[0]
  //                 .registered_business_address_state !== undefined &&
  //               apiResponse.data.results.data[0]
  //                 .registered_business_address_state !== ""
  //             ) {
  //               // getCityByStateForShipping(
  //               //   apiResponse.data.results.data[0]
  //               //     .registered_business_address_state
  //               // );
  //             }
  //             setState({
  //               ...filteredResponse,
  //               vendor_inquiry_value:
  //                 apiResponse.data.results.data[0].inquiry_value.map(
  //                   (inquiryDetail) => {
  //                     const {
  //                       id,
  //                       vendor,
  //                       vendor_name,
  //                       category_tree_name,
  //                       company_name,
  //                       company,
  //                       ...rest
  //                     } = inquiryDetail;
  //                     return {
  //                       company: CompanyId,
  //                       ...rest,
  //                     };
  //                   }
  //                 ),
  //               vendor_company_code: {
  //                 id: apiResponse.data.results.data[0]
  //                   .vendor_company_code_data[0].id,
  //                 company: CompanyId,
  //                 vendor_code_by_company:
  //                   apiResponse.data.results.data[0].vendor_company_code_data[0]
  //                     .vendor_code_by_company,
  //               },
  //               assign_city_to_vendor:
  //                 apiResponse?.data?.results?.data[0]?.assign_city?.map(
  //                   (inquiryDetail) => {
  //                     const {
  //                       id,
  //                       vendor,
  //                       vendor_name,
  //                       city_name,
  //                       company_name,
  //                       material_type_name,
  //                       ...rest
  //                     } = inquiryDetail;
  //                     return {
  //                       company: CompanyId,
  //                       ...rest,
  //                     };
  //                   }
  //                 ),
  //             });

  //             console.log("1");
  //             console.log("vendor_code_by_company:", apiResponse.data.results.data[0].vendor_company_code_data);
  //             // getCityByStateForShipping(apiResponse.data.results.data[0].state);
  //             setFileLink(apiResponse.data.results.data[0].msme_document);
  //             const url = apiResponse.data.results.data[0].vendor_logo;
  //             setIdentifyProfileUrl(
  //               apiResponse.data.results.data[0].vendor_logo
  //             );
  //             if (url !== null) {
  //               setFileList([
  //                 {
  //                   // uid: '-1',
  //                   // name: 'image.png',
  //                   // status: 'done',
  //                   url: url,
  //                 },
  //               ]);
  //             }
  //             console.log("2");
  //             setShowKeyPersonCollapse(true);
  //             // setShowVendorCommunicationCollapse(true);
  //             const newItem =
  //               apiResponse.data.results.data[0].inquiry_value.map((item) => {
  //                 return item.category_tree;
  //               });
  //             console.log("3");
  //             setDisabledOptions(newItem);
  //             formRef.current.setFieldsValue({
  //               ...apiResponse.data.results.data[0],
  //               pincode: apiResponse.data.results.data[0].pincode_name,
  //               phone: String(apiResponse.data.results.data[0].phone),
  //               msme: apiResponse.data.results.data[0].msme,
  //               registered_business_address_pincode:
  //                 apiResponse.data.results.data[0]
  //                   ?.registered_business_address_pincode_number,
  //               trading_address_pincode:
  //                 apiResponse.data.results.data[0]
  //                   .trading_address_pincode_number,
  //               // category: apiResponse.data.results.data[0].category.map(function (
  //               //   el
  //               // ) {
  //               //   return el.id;
  //               // }),
  //               // vendor_code_by_company:
  //               //   apiResponse.data.data.vendor_company_code[0]
  //               //     .vendor_code_by_company,
  //               // assign_site_to_vendor:
  //               //   apiResponse.data.results.data[0].assign_site_to_vendor.map(
  //               //     function (el) {
  //               //       return el.id;
  //               //     }
  //               //   ),
  //             });
  //             if (
  //               apiResponse.data.results.data[0]
  //                 .registered_business_address_building ===
  //               apiResponse.data.results.data[0]?.trading_address_building &&
  //               apiResponse.data.results.data[0]
  //                 ?.registered_business_address_area ===
  //               apiResponse.data.results.data[0]?.trading_address_area &&
  //               apiResponse.data.results.data[0]
  //                 ?.registered_business_address_landmark ===
  //               apiResponse.data.results.data[0]?.trading_address_landmark &&
  //               apiResponse.data.results.data[0]
  //                 ?.registered_business_address_state ===
  //               apiResponse.data.results.data[0]?.trading_address_state &&
  //               apiResponse.data.results.data[0]
  //                 ?.registered_business_address_city ===
  //               apiResponse.data.results.data[0]
  //                 ?.registered_business_address_city &&
  //               apiResponse.data.results.data[0]
  //                 ?.registered_business_address_pincode ===
  //               apiResponse.data.results.data[0]?.trading_address_pincode
  //             ) {
  //               setSameAsRegisteredBusinessAddress(true);
  //             }
  //             setSelectedOption(apiResponse.data.results.data[0].msme);

  //             let modifiedInquiryDetails =
  //               apiResponse.data.results.data[0].inquiry_value.map(
  //                 (inquiry) => {
  //                   const { id, vendor, category_tree_name, ...rest } = inquiry;
  //                   return rest;
  //                 }
  //               );

  //             let modifiedAssignCityDetails =
  //               apiResponse.data.results.data[0].assign_city.map((inquiry) => {
  //                 const { id, vendor, category_tree_name, ...rest } = inquiry;
  //                 return rest;
  //               });
  //             console.log("6");
  //             setWeightSizeInquiryFieldValue(modifiedInquiryDetails);
  //             setWeightSizeAssignCityValue(modifiedAssignCityDetails);
  //             setShowKeyPersonCollapse(true);
  //             setShowVendorCommunicationCollapse(true);
  //             setShowBankDetailsCollapse(true);
  //             setShowAssignSiteCollapse(true);
  //             setShowPaymentCollapse(true);
  //           }

  //           else {
  //             setgstVendorId(null);
  //             setFormSubmitted(false);
  //             setapiloading(false);

  //             const newState = {
  //               ...initialState,
  //               gst_no: value,
  //               // unique_code: null,
  //             };
  //             console.log("9");
  //             setState({ ...initialState, gst_no: value });
  //             setDisabledOptions([]);
  //             setFileLink(null);
  //             console.log("9");
  //             const defaultCountryCode = "+91";
  //             formRef.current.setFieldsValue({
  //               ...initialState,
  //               gst_no: value,
  //               phone: defaultCountryCode,
  //               //  bankdetails: emptyBankDetails,
  //             });
  //             console.log("10");
  //             state.vendor_inquiry_value.forEach((person, index) => {
  //               formRef.current.setFieldsValue({
  //                 [`category_tree${index}`]: "Cement",
  //                 [`minimum_inquiry_value${index}`]: null,
  //                 [`minimum_income_measurement${index}`]: "Lakh",
  //                 [`maximum_inquiry_value${index}`]: null,
  //                 [`maximum_income_measurement${index}`]: "Lakh",
  //               });
  //             });
  //             // state.vendor_company_code.forEach((person, index) => {
  //             formRef.current.setFieldsValue({
  //               [`company`]: CompanyId,
  //               [`vendor_code_by_company`]: null,
  //               [`id`]: null,

  //             });
  //             // });

  //             const url = null;
  //             setIdentifyProfileUrl("");
  //             setFileList([
  //               // {
  //               //   // uid: '-1',
  //               //   // name: 'image.png',
  //               //   // status: 'done',
  //               //   url: "",
  //               // },
  //             ]);

  //             // state.keypersons.forEach((person, index) => {
  //             //   formRef.current.setFieldsValue({
  //             //     [`person_name${index}`]: null,
  //             //     [`email${index}`]: null,
  //             //     [`designation${index}`]: null,
  //             //     [`contact_number${index}`]: defaultCountryCode,
  //             //   });
  //             // });
  //             // state.bankdetails.forEach((bank, index) => {
  //             //   formRef.current.setFieldsValue({
  //             //     [`account_holder_name${index}`]: null,
  //             //     [`account_number${index}`]: null,
  //             //     [`bank_name${index}`]: null,
  //             //     [`branch_name${index}`]: null,
  //             //     [`ifsc_code${index}`]: null,
  //             //   });
  //             // });

  //             // formRef.current.setFieldsValue({
  //             //   ...initialDocument,
  //             //   document_name: null,
  //             // });
  //           }
  //         } else {
  //           ErrorNotificationMsg(t("Vendor Already Exist"));
  //           setapiloading(false);
  //         }
  //       }
  //     } catch (error) {
  //       setapiloading(false);
  //       console.error("Error fetching vendor details:", error);
  //       // Handle error scenarios here
  //       // setapiloading(false);
  //     }
  //   }, 1200),
  //   []
  // );

  const debouncedFetchData = useCallback(
    debounce(async (value) => {
      //onTypeGst(value);

      try {
        // Update the state with the entered GST number

        if (value !== "" && VendorId === null) {
          setapiloading(true);
          setGstValue(value);
          // Make the API call with the provided GST number
          const apiResponse = await getRequest(
            `get-vendor-by-gst/?gst_no=${value}`
          );
          //console.log('apiResponse114 ', apiResponse);

          // if (apiResponse.status && apiResponse.data.results.data.length > 0) {

          if (!flag) {
            if (apiResponse.data.results.data.length > 0) {
              const {
                pincode_name,
                unique_code,
                // vendor_company_data,
                id,
                company_payment_terms,
                keypersons,
                bankdetails,
                assgin_city,
                inquiry_value,
                vendor_company_code_data,
                ...filteredResponse
              } = apiResponse.data.results.data[0];

              setapiloading(false);
              setgstVendorId(apiResponse.data.results.data[0].id);
              setPostGeneratedVendorId(null); //When I get GST ID make Vendor ID Null

              if (
                apiResponse.data.results.data[0].trading_address_state !==
                  null &&
                apiResponse.data.results.data[0].trading_address_state !==
                  undefined &&
                apiResponse.data.results.data[0].trading_address_state !== ""
              ) {
                // getCityByStateTrading(
                //   apiResponse.data.results.data[0].trading_address_state
                // );
              }
              if (
                apiResponse.data.results.data[0]
                  .registered_business_address_state !== null &&
                apiResponse.data.results.data[0]
                  .registered_business_address_state !== undefined &&
                apiResponse.data.results.data[0]
                  .registered_business_address_state !== ""
              ) {
                // getCityByStateForShipping(
                //   apiResponse.data.results.data[0]
                //     .registered_business_address_state
                // );
              }
              setState({
                ...filteredResponse,
                vendor_inquiry_value:
                  apiResponse.data.results.data[0].inquiry_value.map(
                    (inquiryDetail) => {
                      const {
                        id,
                        vendor,
                        vendor_name,
                        category_tree_name,
                        company_material_type,
                        company_name,
                        company,
                        ...rest
                      } = inquiryDetail;
                      return {
                        company: CompanyId,
                        ...rest,
                      };
                    }
                  ),
                vendor_company_code: {
                  id: apiResponse.data.results.data[0]
                    .vendor_company_code_data[0].id,
                  company: CompanyId,
                  vendor_code_by_company:
                    apiResponse.data.results.data[0].vendor_company_code_data[0]
                      .vendor_code_by_company,
                },
                // assign_city_to_vendor:
                //   apiResponse?.data?.results?.data[0]?.assign_city?.map(
                //     (inquiryDetail) => {
                //       const {
                //         id,
                //         vendor,
                //         vendor_name,
                //         city_name,
                //         company_name,
                //         material_type_name,
                //         ...rest
                //       } = inquiryDetail;
                //       return {
                //         company: CompanyId,
                //         ...rest,
                //       };
                //     }
                //   ),
              });

              //console.log("1");
              //console.log("vendor_code_by_company:", apiResponse.data.results.data[0].vendor_company_code_data);
              // getCityByStateForShipping(apiResponse.data.results.data[0].state);
              setFileLink(apiResponse.data.results.data[0].msme_document);
              const url = apiResponse.data.results.data[0].vendor_logo;
              setIdentifyProfileUrl(
                apiResponse.data.results.data[0].vendor_logo
              );
              if (url !== null) {
                setFileList([
                  {
                    // uid: '-1',
                    // name: 'image.png',
                    // status: 'done',
                    url: url,
                  },
                ]);
              }
              //console.log("2");
              setShowKeyPersonCollapse(true);

              // setShowVendorCommunicationCollapse(true);
              const newItem =
                apiResponse.data.results.data[0].inquiry_value.map((item) => {
                  return item.category_tree;
                });
              //console.log("3");
              setDisabledOptions(newItem);
              formRef.current.setFieldsValue({
                ...apiResponse.data.results.data[0],
                pincode: apiResponse.data.results.data[0].pincode_name,
                phone: String(apiResponse.data.results.data[0].phone),
                msme: apiResponse.data.results.data[0].msme,
                registered_business_address_pincode:
                  apiResponse.data.results.data[0]
                    ?.registered_business_address_pincode_number,
                trading_address_pincode:
                  apiResponse.data.results.data[0]
                    .trading_address_pincode_number,
                // category: apiResponse.data.results.data[0].category.map(function (
                //   el
                // ) {
                //   return el.id;
                // }),
                // vendor_code_by_company:
                //   apiResponse.data.data.vendor_company_code[0]
                //     .vendor_code_by_company,
                // assign_site_to_vendor:
                //   apiResponse.data.results.data[0].assign_site_to_vendor.map(
                //     function (el) {
                //       return el.id;
                //     }
                //   ),
              });
              if (
                apiResponse.data.results.data[0]
                  .registered_business_address_building ===
                  apiResponse.data.results.data[0]?.trading_address_building &&
                apiResponse.data.results.data[0]
                  ?.registered_business_address_area ===
                  apiResponse.data.results.data[0]?.trading_address_area &&
                apiResponse.data.results.data[0]
                  ?.registered_business_address_landmark ===
                  apiResponse.data.results.data[0]?.trading_address_landmark &&
                apiResponse.data.results.data[0]
                  ?.registered_business_address_state ===
                  apiResponse.data.results.data[0]?.trading_address_state &&
                apiResponse.data.results.data[0]
                  ?.registered_business_address_city ===
                  apiResponse.data.results.data[0]
                    ?.registered_business_address_city &&
                apiResponse.data.results.data[0]
                  ?.registered_business_address_pincode ===
                  apiResponse.data.results.data[0]?.trading_address_pincode
              ) {
                setSameAsRegisteredBusinessAddress(true);
              }
              setSelectedOption(apiResponse.data.results.data[0].msme);

              if (
                apiResponse?.data?.results?.data[0]?.email_verified === true
              ) {
                setVerificationResultEmail("success");
                setVerifyEmailButtonView(false);
              } else {
                setVerificationResultEmail(null);
                setVerifyEmailButtonView(true);
              }

              if (
                apiResponse?.data?.results?.data[0]?.phone_verified === true
              ) {
                setVerificationResultContact("success");
                setVerifyPhoneButtonView(false);
              } else {
                setVerificationResultContact(null);
                setVerifyPhoneButtonView(true);
              }

              // if (apiResponse?.data?.results?.data[0]?.gst_no_verified === true) {
              //   setVerificationStatus("success");
              //   setVerifyGstButtonView(false);
              // } else {
              //   setVerificationStatus(null);
              //   setVerifyGstButtonView(true);
              // }

              if (
                apiResponse?.data?.results?.data[0]
                  ?.udyam_aadhaar_no_verified === true
              ) {
                setVerificationResultAadhaar("success");
                setVerifyAdhaarButtonView(false);
              } else {
                setVerificationResultAadhaar(null);
                setVerifyAdhaarButtonView(true);
              }

              let modifiedInquiryDetails =
                apiResponse.data.results.data[0].inquiry_value.map(
                  (inquiry) => {
                    const { id, vendor, category_tree_name, ...rest } = inquiry;
                    return rest;
                  }
                );

              let modifiedAssignCityDetails =
                apiResponse.data.results.data[0].assign_city.map((inquiry) => {
                  const { id, vendor, category_tree_name, ...rest } = inquiry;
                  return rest;
                });
              console.log("6");
              setWeightSizeInquiryFieldValue(modifiedInquiryDetails);
              setWeightSizeAssignCityValue(modifiedAssignCityDetails);
              setShowKeyPersonCollapse(true);
              setShowVendorCommunicationCollapse(true);
              setShowVendorBillingDetails(true);
              setShowBankDetailsCollapse(true);
              setShowAssignSiteCollapse(true);
              setShowPaymentCollapse(true);
              setShowPaymentPersonReleasedField(true);
              setShowBankDetailsWithoutCollapse(false);
            } else {
              setgstVendorId(null);
              setFormSubmitted(false);
              setapiloading(false);
              setShowKeyPersonCollapse(false);
              setShowVendorCommunicationCollapse(false);
              setShowAssignSiteCollapse(false);

              setShowVendorBillingDetails(false);
              setShowBankDetailsCollapse(false);
              setShowPaymentCollapse(false);
              setShowPaymentPersonReleasedField(false);
              const newState = {
                ...initialState,
                gst_no: value,
                // unique_code: null,
              };
              console.log("9");
              setState({ ...initialState, gst_no: value });
              setDisabledOptions([]);
              setFileLink(null);
              console.log("9");
              const defaultCountryCode = "+91";
              formRef.current.setFieldsValue({
                ...initialState,
                gst_no: value,
                phone: defaultCountryCode,
                //  bankdetails: emptyBankDetails,
              });
              console.log("10");
              state.vendor_inquiry_value.forEach((person, index) => {
                formRef.current.setFieldsValue({
                  [`category_tree${index}`]: "Cement",
                  [`minimum_inquiry_value${index}`]: null,
                  [`minimum_income_measurement${index}`]: "Lakh",
                  [`maximum_inquiry_value${index}`]: null,
                  [`maximum_income_measurement${index}`]: "Lakh",
                });
              });
              // state.vendor_company_code.forEach((person, index) => {
              formRef.current.setFieldsValue({
                [`company`]: CompanyId,
                [`vendor_code_by_company`]: null,
                [`id`]: null,
              });
              // });

              const url = null;
              setIdentifyProfileUrl("");
              setFileList([
                // {
                //   // uid: '-1',
                //   // name: 'image.png',
                //   // status: 'done',
                //   url: "",
                // },
              ]);

              // state.keypersons.forEach((person, index) => {
              //   formRef.current.setFieldsValue({
              //     [`person_name${index}`]: null,
              //     [`email${index}`]: null,
              //     [`designation${index}`]: null,
              //     [`contact_number${index}`]: defaultCountryCode,
              //   });
              // });
              // state.bankdetails.forEach((bank, index) => {
              //   formRef.current.setFieldsValue({
              //     [`account_holder_name${index}`]: null,
              //     [`account_number${index}`]: null,
              //     [`bank_name${index}`]: null,
              //     [`branch_name${index}`]: null,
              //     [`ifsc_code${index}`]: null,
              //   });
              // });

              // formRef.current.setFieldsValue({
              //   ...initialDocument,
              //   document_name: null,
              // });
            }

            // const gst = state?.gst_no;
            // if(apiResponse.data.count === 0){
            //   const response = await getRequest(`doc-verification/gst/?gst_no=${gst}`);

            //   console.log('response', response);

            // }
          } else {
            ErrorNotificationMsg(t("Vendor Already Exist"));
            setapiloading(false);
          }
        }
      } catch (error) {
        setapiloading(false);
        console.error("Error fetching vendor details:", error);
        // Handle error scenarios here
        // setapiloading(false);
      }
    }, 1200),
    []
  );

  useEffect(() => {
    return () => {
      debouncedFetchData.cancel();
    };
  }, [debouncedFetchData]);
  // const handleStateChange = (values) => {
  //   console.log(values, "Valuessss");
  //   // const updatedAssignSite = [...state.assgin_site]; // Copying the array to avoid mutating state directly
  //   // updatedAssignSite[0] = {
  //   //   ...updatedAssignSite[0],
  //   //   category_tree: values,
  //   //   material_type: null,
  //   // }; // Updating the category_tree field
  //   setState({ ...state, state: values, city: null }); // Updating the state with the new category_tree value
  //   setCityDropdownOptionsAddVendor([]);
  //   formRef.current.setFieldsValue({
  //     ...state,
  //     state: values,
  //     city: "",
  //   });
  //   // Fetch material types based on the selected category
  //   if (values !== null && values !== undefined) {
  //     getCityByState(values); //1 0
  //   }
  // };
  // const handleCityChange = (values) => {
  //   // const updatedAssignSite = [...state.assgin_site]; // Copying the array to avoid mutating state directly
  //   // updatedAssignSite[0] = { ...updatedAssignSite[0], material_type: values }; // Updating the category_tree field
  //   setState({ ...state, billing_city: values }); // Updating the state with the new category_tree value
  // };
  // const getCityByState = async (StateId) => {
  //   await getRequest(`city/${StateId}/`).then((response) => {
  //     {
  //       console.log(response, "RESPONSEEEEEE");
  //     }
  //     setCityDropdownOptions(response.data.data);
  //   });
  // };
  // const getState = async () => {
  //   await getRequest("state/?no_pagination=true").then((response) => {
  //     {
  //       console.log(response, "RESPONSEEEEEE");
  //     }
  //     setStateDropdownOptions(response.data.data);
  //   });
  // };
  // const handleGstInputChange = async (value) => {
  //   setState({ ...state, gst_no: value });
  //   // Debounce the API call to avoid immediate firing on each keystroke
  //   debouncedFetchData(value, onTypeGst);
  //   console.log("handleGST");
  //   setVerificationResultGST('');
  //   setVerificationResultContact('');
  //   setVerificationResultPancard('');
  //   setVerificationResultEmail('');
  //   // debouncedFetchData(value);
  // };
  const gstPattern =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  const handleGstInputChange = async (e) => {
    let { name, value } = e.target;
    setVerifyGstButtonView(true);

    setState({ ...state, gst_no: value, gst_no_verified: false });
    // Debounce the API call to avoid immediate firing on each keystroke
    setVerificationStatus(null);
    setVerifyDisable(!gstPattern.test(value));

    debouncedFetchData(value);
  };

  // const handleGstInputChangeCity = (value) => {
  //   // const updatedAssignSite = [...state.assgin_site]; // Copying the array to avoid mutating state directly
  //   // updatedAssignSite[0] = { ...updatedAssignSite[0], gst_number: value }; // Updating the category_tree field
  //   setState({ ...state, gst_number: value }); // Updating the state with the new category_tree value
  // };
  const onTypeGst = (value) => {
    setState({
      ...state,
      gst_no: value,
    });
  };

  // const handleGstInputChange = async (value) => {
  //   try {
  //     // Update the state with the entered GST number
  //     setState({ ...state, gst_no: value });

  //     if (value !== '') {
  //       // Make the API call with the provided GST number
  //       const apiResponse = await getRequest(`get-vendor-by-gst/?gst_no=${value}`);

  //       if (apiResponse.status && apiResponse.data.results.data.length > 0) {
  //         // Process the API response when data is returned
  //         const vendorData = apiResponse.data.results.data[0];
  //         const modifiedCategory = vendorData.category.map(el => el.id);
  //         const modifiedBankDetails = vendorData.bankdetails.map(({ id, vendor, ...rest }) => rest);
  //         const modifiedKeyPersons = vendorData.keypersons.map(({ id, vendor, vendor_name, ...rest }) => rest);
  //         setState({
  //           ...vendorData,
  //           category: modifiedCategory,
  //           bankdetails: modifiedBankDetails,
  //           keypersons: modifiedKeyPersons,
  //         });
  //         setSelectedOption(apiResponse.data.results.data[0].msme);
  //         setFileLink(apiResponse.data.results.data[0].msme_document);

  //         // Update form fields
  //         formRef.current.setFieldsValue({
  //           ...vendorData,
  //           pincode: vendorData.pincode,
  //           phone: String(vendorData.phone),
  //           msme: vendorData.msme,
  //           category: modifiedCategory,
  //         });
  //         setWeightSizeFieldValue(modifiedKeyPersons);
  //         setWeightSizeBankFieldValue(modifiedBankDetails);
  //         // Other state updates and form field value setting

  //       } else {
  //         // When API response is empty
  //         setState({
  //           gst_no: '', // Resetting GST number in state
  //           // Resetting other state properties if needed...
  //         });

  //         // Reset form fields if required
  //         formRef.current.resetFields();
  //       }

  //       // Additional state updates and actions after API call
  //       // setFormSubmitted(true);
  //       // setAddedVendorId(VendorId);
  //       // setapiloading(false);

  //     }
  //   } catch (error) {
  //     console.error('Error fetching vendor details:', error);
  //       // Handle error scenarios here
  //     // setapiloading(false);
  //   }
  // };

  const handleSelectChange = (name, value) => {
    setState({ ...state, [name]: value });
    // Check if the name is one of the specified fields
    // if (["days_to_pay", "when_to_pay", "when_to_calculate"].includes(name)) {
    //   // setGstVendorState((prevGstVendorState) => ({
    //   //   ...prevGstVendorState,
    //   //   [name]: value,
    //   // }));
    // }
  };
  // const handleCategoryChange = (values) => {
  //   setState({ ...state, category: values });
  // };

  const handleOptionChange = (name, value) => {
    if (value === false) {
      setState({ ...state, [name]: value, msme_number: null });
      setSelectedOption(false);
      formRef.current.setFieldsValue({
        msme_number: "",
      });
      setState((prevState) => ({
        ...prevState,
        msme_document: null,
      }));
      setUploadFile("");
      setFileName(null);
      setFileLink(null);
      setSize(null);
    } else {
      setState({ ...state, [name]: value });
      setSelectedOption(value);
    }
  };
  const handleChange = (name, value) => {
    setState({ ...state, [name]: value });
    // setGstVendorState((prevGstVendorState) => ({
    //   ...prevGstVendorState,
    //   [name]: value,
    // }));
  };

  const handlePincodeChange = (name, value) => {
    // Assuming you have a state variable called 'pincode'
    // setPincode(!value ? "" : value); // Set 'pincode' state to pincode_number

    // If you have another state variable called 'selectedPincodeId', set it to the corresponding 'id'
    const selectedOption = pincodeList.find(
      (option) => option.pincode_number === value
    );
    const selectedId = selectedOption ? selectedOption.id : null;
    // setSelectedPincodeId(selectedId);
    setState({ ...state, [name]: selectedId });
  };
  const searchIN = async (value) => {
    // http://127.0.0.1:8000/pincode/?search_pincode_number=38001
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    //     setPincodeList(apiResponse.data.results.data);
    //   });
    // const apiResponse = await getRequest(
    //   `facility/list-facility-search/?search_on=${searchOn}&search_text=${value}`
    // );
    if (apiResponse.data.results.success) {
      // setPincodeList(
      //   apiResponse.data.results.data.map(function (el) {
      //     return el.pincode_number;
      //   })
      // );
      setPincodeList(apiResponse.data.results.data);
      // setSuggestions(
      //   apiResponse.data.data.map(function (el) {
      //     return el.formulation_type;
      //   })
      // );
    }
  };
  const onSelect = (data) => {
    // setSearch(!data ? "" : data);
    setSearchValue(!data ? "" : data);
    // const selectedOption = pincodeList.find(
    //   (option) => option.pincode_number === data
    // );
    // const selectedId = selectedOption ? selectedOption.id : null;
    // // setSelectedPincodeId(selectedId);
    // setState({ ...state, pincode: selectedId });
  };
  // const onSearchBilling = async (value) => {
  //   // setSearch(!value ? "" : value);
  //   setSearchValueBilling(value);
  //   // value.length === 0 ? setSearch(value) : setPincodeList([]);
  //   value.length >= 4
  //     ? searchINBillingRegistered(!value ? null : value)
  //     : setPincodeListBillingRegistered([]);
  //   // if (value.length >= 2) {
  //   //   searchIN(!value ? null : value);
  //   //   // setSearch(!value ? "" : value);
  //   //   // searchBusinessLounge(value);
  //   // } else {
  //   //   setPincodeList([]);
  //   // }
  // };

  const searchINBillingRegistered = async (value) => {
    // http://127.0.0.1:8000/pincode/?search_pincode_number=38001
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    if (apiResponse.data.results.success) {
      setPincodeListBillingRegistered(apiResponse.data.results.data);
    }
  };
  const [searchValueBillingRegistered, setSearchValueBillingResgistered] =
    useState("");

  const onSearchBillingResgistered = async (value) => {
    // setSearch(!value ? "" : value);
    setSearchValueBillingResgistered(value);
    // value.length === 0 ? setSearch(value) : setPincodeList([]);
    value.length >= 4
      ? searchINBillingRegistered(!value ? null : value)
      : setPincodeListBillingRegistered([]);
    // if (value.length >= 2) {
    //   searchIN(!value ? null : value);
    //   // setSearch(!value ? "" : value);
    //   // searchBusinessLounge(value);
    // } else {
    //   setPincodeList([]);
    // }
  };
  const [searchValueShippingTrading, setSearchValueShippingTrading] =
    useState("");
  const [pincodeListShippingtrading, setPincodeListShippingTrading] = useState(
    []
  );
  const searchINShippingTrading = async (value) => {
    // http://127.0.0.1:8000/pincode/?search_pincode_number=38001
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    if (apiResponse.data.results.success) {
      setPincodeListShippingTrading(apiResponse.data.results.data);
    }
  };
  const onSearchShippingTrading = async (value) => {
    // setSearch(!value ? "" : value);
    setSearchValueShippingTrading(value);
    // value.length === 0 ? setSearch(value) : setPincodeList([]);
    value.length >= 4
      ? searchINShippingTrading(!value ? null : value)
      : setPincodeListShippingTrading([]);
    // if (value.length >= 2) {
    //   searchIN(!value ? null : value);
    //   // setSearch(!value ? "" : value);
    //   // searchBusinessLounge(value);
    // } else {
    //   setPincodeList([]);
    // }
  };
  const handlePincodeShippingTradingChange = async (
    trading_address_pincode
  ) => {
    try {
      const response = await getRequest(
        `pincode/?search_pincode_number=${trading_address_pincode}`
      );
      console.log(response, "responsed");
      if (response.data.results.data.length > 0) {
        const { state_name, city_name, id } = response.data.results.data[0];
        setState((prevState) => ({
          ...prevState,
          trading_address_state: state_name,
          trading_address_city: city_name,
          trading_address_pincode: id,
        }));
        formRef.current.setFieldsValue({
          trading_address_state: state_name,
          trading_address_city: city_name,
        });
      }
      // setApiLoading(false);
    } catch (error) {
      // setApiLoading(false);
      console.error("Error fetching state and city:", error);
    }
  };
  const onSelectBilling = (data) => {
    // setSearch(!data ? "" : data);
    setSearchValueBilling(!data ? "" : data);
    // const selectedOption = pincodeList.find(
    //   (option) => option.pincode_number === data
    // );
    // const selectedId = selectedOption ? selectedOption.id : null;
    // // setSelectedPincodeId(selectedId);
    // setState({ ...state, pincode: selectedId });
  };
  const onSearch = async (value) => {
    // setSearch(!value ? "" : value);
    setSearchValue(value);
    // value.length === 0 ? setSearch(value) : setPincodeList([]);
    value.length >= 4 ? searchIN(!value ? null : value) : setPincodeList([]);
    // if (value.length >= 2) {
    //   searchIN(!value ? null : value);
    //   // setSearch(!value ? "" : value);
    //   // searchBusinessLounge(value);
    // } else {
    //   setPincodeList([]);
    // }
  };
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      setErrorMsg("You can only upload JPG/PNG file!");
      message.error("You can only upload JPG/PNG file!");
      return Upload.LIST_IGNORE;
    }
    setErrorMsg(""); // Clear error message if file type is correct
    return false; // Prevent automatic upload, will handle manually
  };

  const uploadProps = {
    accept: ".jpg, .png, .jpeg",
    showUploadList: false,
    beforeUpload: (file, name) => {
      setUploadFile(file);
      setFileName(file.name);

      return false;
    },
  };

  const uploadPropsOne = {
    accept: ".jpg, .png, .jpeg",
    showUploadList: false,
    beforeUpload: (file, name) => {
      setUploadFileOne(file);
      setFileNameOne(file.name);
      return false;
    },
  };

  const handleDelete = (name) => {
    if (name === "msme_document") {
      setState((prevState) => ({
        ...prevState,
        msme_document: null,
      }));
      setUploadFile("");
      setFileName(null);
      setFileLink(null);
      setSize(null);
    } else if (name === "document_url") {
      setState((prevState) => ({
        ...prevState,
        document_url: null,
      }));
      setUploadFileOne("");
      setFileNameOne(null);
      setFileLinkOne(null);
      setSizeOne(null);
    }
  };

  const updateSubscriptionStatus = async () => {
    const response = await getRequest(`user-detail/${userId}`);

    localStorage.setItem("auth_data", JSON.stringify(response.data.data));
  };

  const handleFileDelete = async (name) => {
    const apiResponse = await deleteRequest(
      `vendor/${VendorId}/msme-document-delete/`
    );
    if (apiResponse.status) {
      // message.success("Image deleted successfully");
      if (name === "msme_d6 9ocument") {
        setFileName(null);
        setFileLink(null);
        setSize(null);
      } else if (name === "document_url") {
        setFileNameOne(null);
        setFileLinkOne(null);
        setSizeOne(null);
      }
    }
  };

  // const getCityByState = async (StateId) => {
  //   await getRequest(`city/${StateId}/`).then((response) => {
  //     {
  //       console.log(response, "RESPONSEEEEEE");
  //     }
  //     setCityDropdownOptions(response.data.data);
  //   });
  // };

  const handleRefreshGrid = () => {
    // This function will be called to trigger a refresh of the grid
    setRefreshGrid((refreshGrid) => !refreshGrid);
  };
  //  const handleGstNumberVerify = async () => {
  //     try {
  //       setBtnLoading(true);
  //       const gst = state?.gst_no;

  //       const response = await getRequest(`get-vendor-by-gst/?gst_no=${gst}`);
  //       console.log(response, "responseddd")
  //       if (response.data.results.data) {
  //         // SuccessNotificationMsg(
  //         //   state.id === null
  //         //     ? t("zone_name_added_successfully2")
  //         //     : t("zone_name_updated_successfully2")
  //         // );
  //         // if (state.id === null) {
  //           SuccessNotificationMsg("GST Verify Successfully");
  //         // }
  //         setBtnLoading(false);
  //       } else {
  //         // Handle case when GST number is not valid
  //         ErrorNotificationMsg(t("Invalid GST Number"));
  //         setBtnLoading(false);
  //       }
  //     } catch (error) {
  //       ErrorNotificationMsg(t("Error in verifying GST number"));
  //       setBtnLoading(false);
  //     }
  //   };
  const handleClonePhoneInputChange = (field, phone, index) => {
    let newPersonArr = state.suppliers_billing_details;
    newPersonArr[index][field] = phone ? phone : null;
    setState({ ...state, suppliers_billing_details: newPersonArr });
  };

  // const handleGstNumberVerify = async () => {
  //   try {
  //     const gst = state?.gst_no;

  //     const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  //     if (!gst || !gstRegex.test(gst)) {
  //       ErrorNotificationMsg(t("Invalid GST No."));
  //       setVerificationResultGST('error');
  //       return;
  //     }

  //     setBtnLoading(true);
  //     const response = await getRequest(`get-vendor-by-gst/?gst_no=${gst}`);
  //     console.log(response, "responseddd");
  //     if (response.data.results.data) {
  //       SuccessNotificationMsg("GST verified successfully");
  //       setVerificationResultGST('success');
  //       setBtnLoading(false);
  //     } else {
  //       // Handle case when GST number is not valid
  //       ErrorNotificationMsg(t("Invalid GST No."));
  //       setVerificationResultGST('error');
  //       setBtnLoading(false);
  //     }
  //   } catch (error) {
  //     ErrorNotificationMsg(t("Error in verifying GST number"));
  //     setVerificationResultGST('error');
  //     setBtnLoading(false);
  //   }
  // };

  const handleSendOtpEmail = async () => {
    try {
      const payload = {
        email: state?.email ? state.email : "",
      };

      // setBtnLoadingEmail(true);
      const response = await postRequest(`verified-otp/email-verify/`, payload);
      console.log(response, "responseddd");
      if (response.data.success) {
        const errorMessage = response?.data?.message || ""; // Adjust this line to get the message from your error response

        const emailVerificationRegex = /This [^ ]+ already Verify/; // Regex to match the email format in the message

        // Check if the error message matches the condition
        if (emailVerificationRegex.test(errorMessage)) {
          setVerifyEmailButtonView(false);

          setState((prevState) => ({
            ...prevState,
            email_verified: true,
          }));
          // setBtnLoading(false);
          setVerificationResultEmail("success");
        } else {
          setState((prevState) => ({
            ...prevState,
            email_verified: false,
          }));
          showModal();
          setVerifyEmailButtonView(true);
          // setBtnLoading(false);
        }
        SuccessNotificationMsg(response.data.message);
      } else {
        handleCancel();
        // setVerifyEmailButtonView(true)
        setVerificationResultEmail("");
        // Handle case when GST number is not valid
        // ErrorNotificationMsg(t(response.data.message));
        // setVerificationResultGST('error');
        // setBtnLoadingEmail(false);
      }
    } catch (error) {
      //         const errorMessage = error.response?.data?.message || ''; // Adjust this line to get the message from your error response
      //     const emailVerificationRegex = /This [^ ]+ Already Verify/; // Regex to match the email format in the message
      // console.log("Hiiiiiiiiiii",emailVerificationRegex.test(errorMessage),errorMessage);
      //     // Check if the error message matches the condition
      //     if (emailVerificationRegex.test(errorMessage)) {
      //       console.log("Inside It want",emailVerificationRegex.test(errorMessage),errorMessage)
      //       setState((prevState) => ({
      //         ...prevState,
      //         email_verified: true,
      //       }));
      //       setVerifyEmailButtonView(false);

      //       setVerificationResultEmail('success');
      //     } else {
      //       setState((prevState) => ({
      //         ...prevState,
      //         email_verified: false,
      //       }));
      //       setVerificationResultEmail('');
      //       setVerifyEmailButtonView(true)
      //     }
      handleCancel();
      setVerifyEmailButtonView(true);
      setVerificationResultEmail("");
      // ErrorNotificationMsg(t("Error in verifying GST number"));
      // setVerificationResultGST('error');
      // setBtnLoadingEmail(false);
    }
  };
  const handleEmailVerify = async () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple email regex pattern
    const isEmailValid = emailPattern.test(state.email);
    if (isEmailValid) {
      await handleSendOtpEmail(); // Call handleSendOtpEmail if email is valid
      // setVerifyEmailButtonView(true);
    } else {
      setVerifyEmailButtonView(true);
      ErrorNotificationMsg("Enter valid email");
    }
  };
  const handlePhoneInputChange = (phone) => {
    setVerifyPhoneButtonView(true);
    // setState({ ...state, phone: phone });
    setState((prevState) => ({
      ...prevState,
      phone: phone,
      phone_verified: false,
    }));
    setVerificationResultContact(""); // Reset verificationResultContact when phone number changes
  };
  const handleSendOtpPhone = async () => {
    try {
      const payload = {
        phone_number: state?.phone ? state.phone : "",
      };

      // setBtnLoadingPhone(true);
      const response = await postRequest(
        `verified-otp/phone-number-verify/`,
        payload
      );
      console.log(response, "responseddd Phone Number");
      if (response.data.success) {
        const errorMessage = response?.data?.message || "";
        const emailVerificationRegex = /This [^ ]+ already Verify/; // Regex to match the email format in the message

        if (emailVerificationRegex.test(errorMessage)) {
          setVerifyPhoneButtonView(false);

          setState((prevState) => ({
            ...prevState,
            phone_verified: true,
          }));
          // setBtnLoading(false);
          setVerificationResultContact("success");
        } else {
          setState((prevState) => ({
            ...prevState,
            phone_verified: false,
          }));
          showModalPhone();
          setVerifyPhoneButtonView(true);
          // setBtnLoading(false);
        }
        // showModalPhone();
        SuccessNotificationMsg(response.data.message);

        // setVerifyPhoneButtonView(true)
        // setBtnLoadingPhone(false);
      } else {
        setVerificationResultContact("");
        handleCancelPhone();
        setVerifyPhoneButtonView(true);
        // Handle case when GST number is not valid
        // ErrorNotificationMsg(t(response.data.message));
        // setVerificationResultGST('error');
        // setBtnLoadingPhone(false);
      }
    } catch (error) {
      setVerifyPhoneButtonView(true);
      handleCancelPhone();
      setVerificationResultContact("");
      // ErrorNotificationMsg(t("Error in verifying GST number"));
      // setVerificationResultGST('error');
      // setBtnLoadingPhone(false);
    }
  };
  const handleContactNumberVerify = async () => {
    const contactNumber = state?.phone;
    const phoneNumberPattern = /^\d{12}$/; // Regex pattern for a 12-digit phone number

    // Validate contact number
    if (contactNumber && phoneNumberPattern.test(contactNumber)) {
      await handleSendOtpPhone(); // Call handleSendOtpPhone if the number is valid
    } else {
      ErrorNotificationMsg("Enter valid mobile number");
    }
  };
  const handleSubmit = async () => {
    const isInquiryValueInvalid = state.vendor_inquiry_value?.some(
      (inquiry) => {
        return (
          inquiry.category_tree === null ||
          inquiry.category_tree === undefined ||
          inquiry.category_tree === "" ||
          inquiry.company_material_type.length === 0 ||
          inquiry.city === null ||
          inquiry.city === undefined ||
          inquiry.city === "" ||
          inquiry.city.length === 0 ||
          inquiry.minimum_inquiry_value === null ||
          inquiry.maximum_inquiry_value === null
        );
      }
    );

    if (isInquiryValueInvalid) {
      ErrorNotificationMsg(
        "Please fill all Vendor Inquiry Value fields before saving."
      );
      return;
    }

    const companyId = state.vendor_inquiry_value[0]?.company;
    const category_tree_materials = state.vendor_inquiry_value.map((row) => ({
      category_tree: row.category_tree,
      company_material_type: row.company_material_type,
      minimum_inquiry_value: row.minimum_inquiry_value,
      maximum_inquiry_value: row.maximum_inquiry_value,
      city: row.city,
    }));
    const vendor_inquiry_value = [
      {
        company: companyId,
        category_tree_materials,
      },
    ];

    const payload = {
      vendor_registered_name: state.vendor_registered_name,
      person_name: state.person_name,
      designation: state.designation,
      // address_line_1: state.address_line_1,
      // address_line_2: state.address_line_2,
      // city: state.city,
      // state: state.state,
      // pincode: state.pincode,
      // website: state.website,
      // no_of_employees: state.no_of_employees,
      // company_pan: state.company_pan,
      gst_no: state.gst_no,
      udyam_aadhaar_no: state.udyam_aadhaar_no,
      gst_no_verified: state.gst_no_verified,
      phone_verified: state.phone_verified,
      email_verified: state.email_verified,

      // about_company: state.about_company,
      email: state.email,
      phone: state.phone,
      // lut_number: state.lut_number,
      // msme: state.msme,
      vendor_trade_name: state.vendor_trade_name,
      // registered_business_address: state.registered_business_address,
      // trading_address: state.trading_address,

      registered_business_address_building:
        state.registered_business_address_building,
      registered_business_address_area: state.registered_business_address_area,
      registered_business_address_landmark:
        state.registered_business_address_landmark,
      registered_business_address_state:
        state.registered_business_address_state,
      registered_business_address_city: state.registered_business_address_city,
      registered_business_address_pincode:
        state.registered_business_address_pincode,
      trading_address_building: state.trading_address_building,
      trading_address_area: state.trading_address_area,
      trading_address_landmark: state.trading_address_landmark,
      trading_address_state: state.trading_address_state,
      trading_address_city: state.trading_address_city,
      trading_address_pincode: state.trading_address_pincode,

      // vendor_inquiry_value:
      //   state.vendor_inquiry_value &&
      //   state.vendor_inquiry_value.every(
      //     (inquiry) =>
      //       inquiry.category_tree === null &&
      //       inquiry.minimum_inquiry_value === null &&
      //       inquiry.maximum_inquiry_value === null &&
      //       inquiry.city === null
      //   )
      //     ? []
      //     : state.vendor_inquiry_value,

      // assign_city_to_vendor:
      //   state.assign_city_to_vendor &&
      //     state.assign_city_to_vendor.every(
      //       (city) =>
      //         city.category_tree === null &&
      //         city.city === null &&
      //         city.state === null

      //     )
      //     ? []
      //     : state.assign_city_to_vendor,

      vendor_inquiry_value,
      vendor_company_code: {
        id: state.vendor_company_code.id,
        company: CompanyId,
        vendor_code_by_company:
          state.vendor_company_code.vendor_code_by_company,
      },
    };

    // const onSearchBilling = async (value) => {
    //   // setSearch(!value ? "" : value);
    //   setSearchValueBilling(value);
    //   // value.length === 0 ? setSearch(value) : setPincodeList([]);
    //   value.length >= 4
    //     ? searchINBilling(!value ? null : value)
    //     : setPincodeListBillingRegistered([]);
    //   // if (value.length >= 2) {
    //   //   searchIN(!value ? null : value);
    //   //   // setSearch(!value ? "" : value);
    //   //   // searchBusinessLounge(value);
    //   // } else {
    //   //   setPincodeList([]);
    //   // }
    // };
    try {
      setBtnLoading(true);
      let apiResponse;
      let customerHeaders = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const formData = new FormData();

      formData.append("vendor_logo", uploadFileProfilePic);
      formData.append("msme_document", uploadFile);
      formData.append("form_data", JSON.stringify(payload));
      if (VendorId === null && gstVendorId === null) {
        apiResponse = await postRequest("vendor/", formData, customerHeaders);
      }
      if (VendorId !== null || gstVendorId !== null) {
        // apiResponse = await patchRequest(
        //   `vendor1/${VendorId}/`,
        //   formData,
        //   customerHeaders
        // );
        const url =
          VendorId !== null ? `vendor/${VendorId}/` : `vendor/${gstVendorId}/`;

        apiResponse = await patchRequest(url, formData, customerHeaders);
      }

      if (apiResponse.data.success === true) {
        // setAddedVendorId(apiResponse.data.data.id);
        setIsGstNoReadOnly(true);
        setPostGeneratedVendorId(apiResponse.data.data.id);
        // Set keyPersonId
        if (apiResponse.data.data.keypersons.length > 0) {
          const keyPersonId =
            apiResponse.data.data.keypersons[0].id !== null
              ? apiResponse.data.data.keypersons[0].id
              : null;

          setKeyPersonId(keyPersonId);
        } else {
          setKeyPersonId(null);
        }

        // Set BankDetailId
        const bankDetailId =
          apiResponse.data.data.bankdetails[0].id !== null
            ? apiResponse.data.data.bankdetails[0].id
            : null;
        setBankDetailId(bankDetailId);

        const supplierBillingId =
          apiResponse.data.data.suppliers_billing_details[0].id !== null
            ? apiResponse.data.data.suppliers_billing_details[0].id
            : null;
        SetSupplierBillingId(supplierBillingId);

        // Set AssignSiteId
        // const assignSiteId =
        //   apiResponse.data.data.assgin_site[0].id !== null
        //     ? apiResponse.data.data.assgin_site[0].id
        //     : null;
        // setAssignSiteId(assignSiteId);

        // Set InquiryValueId
        // const inquiryValueId =
        //   apiResponse.data.data.inquiry_value[0].id !== null
        //     ? apiResponse.data.data.inquiry_value[0].id
        //     : null;
        // setInquiryValueId(inquiryValueId);

        // Set PaymentTermsId
        const paymentTermsId =
          apiResponse.data.data.company_payment_terms[0].id !== null
            ? apiResponse.data.data.company_payment_terms[0].id
            : null;
        setPaymentTermsId(paymentTermsId);

        if (gstVendorId) {
          const matchingPayment =
            apiResponse.data.data.company_payment_terms.find(
              (payment) => payment.company === CompanyId
            );

          const selectedId = matchingPayment ? matchingPayment.id : null;

          setAddedVendorId(selectedId);
        } else {
          setAddedVendorId(
            apiResponse.data.data.company_payment_terms.length > 0
              ? apiResponse.data.data.company_payment_terms[0].id
              : null // or some default value if there are no elements
          );
        }

        setFormSubmitted(true);

        // setState(initialState);
        // formRef.current.setFieldsValue(initialState);
        updateSubscriptionStatus();
        SuccessNotificationMsg(
          VendorId === null
            ? t("vendor_added_successfully")
            : t("vendor_updated_successfully")
        );
        // navigate("/vendor");
      }
      setBtnLoading(false);
      setShowKeyPersonCollapse(true);
      setShowVendorCommunicationCollapse(true);
      // setShowVendorCommunicationCollapse(true);
      // setShowBankDetailsCollapse(true);
      // setShowAssignSiteCollapse(true);
      // setShowPaymentCollapse(true);
    } catch (error) {
      setBtnLoading(false);
      setIsGstNoReadOnly(false);
    }
  };

  const handleCloneCategorySelectChange = (field, value, index) => {
    let newFeatureArr = state.vendor_inquiry_value;
    const newValue = value === undefined ? null : value;
    if (newFeatureArr[index]) {
      newFeatureArr[index][field] = newValue;
      setState({ ...state, vendor_inquiry_value: newFeatureArr });
    }
  };
  // const handlePincodeBillingChange = (name, value) => {
  //   // Assuming you have a state variable called 'pincode'
  //   // setPincode(!value ? "" : value); // Set 'pincode' state to pincode_number

  //   // If you have another state variable called 'selectedPincodeId', set it to the corresponding 'id'
  //   const selectedOption = pincodeListBilling.find(
  //     (option) => option.pincode_number === value
  //   );
  //   const selectedBillingPincode = selectedOption?.pincode_number;

  //   const selectedId = selectedOption ? selectedOption.id : null;
  //   // setSelectedPincodeId(selectedId);
  //   setState({
  //     ...state,
  //     [name]: selectedId,
  //     billing_pincode_number: selectedBillingPincode,
  //   });
  // };
  // console.log("pincodeListShipping", pincodeListShipping);

  // const handlePincodeShippingChange = (name, value) => {

  //   const selectedOption = pincodeListShipping.find(
  //     (option) => option.pincode_number === value
  //   );
  //   const selectedBillingPincode = selectedOption?.pincode_number;

  //   const selectedId = selectedOption ? selectedOption.id : null;
  //   // setSelectedPincodeId(selectedId);
  //   setState({
  //     ...state,
  //     [name]: selectedId,
  //     registered_business_address_pincode_number: selectedBillingPincode,
  //   });
  // };
  const handlePincodeBillingChange = async (
    registered_business_address_pincode
  ) => {
    if (
      registered_business_address_pincode.length > 4 &&
      registered_business_address_pincode !== null &&
      registered_business_address_pincode !== "" &&
      registered_business_address_pincode !== undefined
    ) {
      try {
        const response = await getRequest(
          `pincode/?search_pincode_number=${registered_business_address_pincode}`
        );
        console.log(response, "responsed");
        if (response.data.results.data.length > 0) {
          const { state_name, city_name, id, pincode_number } =
            response.data.results.data[0];
          setState((prevState) => ({
            ...prevState,
            registered_business_address_state: state_name,
            registered_business_address_city: city_name,
            registered_business_address_pincode: id,
            registered_business_address_pincode_number: pincode_number,
          }));
          formRef.current.setFieldsValue({
            registered_business_address_state: state_name,
            registered_business_address_city: city_name,
          });
        }
        // setApiLoading(false);
      } catch (error) {
        // setApiLoading(false);
        console.error("Error fetching state and city:", error);
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        registered_business_address_state: "",
        registered_business_address_city: "",
        registered_business_address_pincode: "",
        registered_business_address_pincode_number: "",
      }));
      formRef.current.setFieldsValue({
        registered_business_address_state: "",
        registered_business_address_city: "",
      });
    }
  };
  const handlePincodeListingChange = async (index, pincode) => {
    try {
      const response = await getRequest(
        `pincode/?search_pincode_number=${pincode}`
      );
      console.log(response, "responsed");
      if (response.data.results.data.length > 0) {
        const { state_name, city_name, id, pincode_number } =
          response.data.results.data[0];
        // setState((prevState) => ({
        //   ...prevState,
        //   state: state_name,
        //   city: city_name,
        //   pincode: id,
        //   pincode_number: pincode_number,
        // }));
        console.log(index, "indexesss", state_name, city_name);
        const updatedAssignCity = [...state.suppliers_billing_details];
        updatedAssignCity[index].pincode = id;
        updatedAssignCity[index].state = state_name;
        updatedAssignCity[index].city = city_name;
        setState({ ...state, suppliers_billing_details: updatedAssignCity });

        //formRef.current.setFieldsValue({ state: state_name, city: city_name });
        formRef.current.setFieldsValue({
          [`state_${index}`]: state_name,
          [`city_${index}`]: city_name,
        });
      }
      // setApiLoading(false);
    } catch (error) {
      // setApiLoading(false);
      console.error("Error fetching state and city:", error);
    }
  };
  const searchINShipping = async (value) => {
    // http://127.0.0.1:8000/pincode/?search_pincode_number=38001
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    //     setPincodeList(apiResponse.data.results.data);
    //   });
    // const apiResponse = await getRequest(
    //   `facility/list-facility-search/?search_on=${searchOn}&search_text=${value}`
    // );
    if (apiResponse.data.results.success) {
      // setPincodeList(
      //   apiResponse.data.results.data.map(function (el) {
      //     return el.pincode_number;
      //   })
      // );
      setPincodeListShipping(apiResponse.data.results.data);
      // setSuggestions(
      //   apiResponse.data.data.map(function (el) {
      //     return el.formulation_type;
      //   })
      // );
    }
  };
  const onSelectShipping = (data) => {
    // setSearch(!data ? "" : data);
    setSearchValueShipping(!data ? "" : data);
    // const selectedOption = pincodeList.find(
    //   (option) => option.pincode_number === data
    // );
    // const selectedId = selectedOption ? selectedOption.id : null;
    // // setSelectedPincodeId(selectedId);
    // setState({ ...state, pincode: selectedId });
  };
  const onSearchShipping = async (value) => {
    // setSearch(!value ? "" : value);
    setSearchValueShipping(value);
    // value.length === 0 ? setSearch(value) : setPincodeList([]);
    value.length >= 4
      ? searchINShipping(!value ? null : value)
      : setPincodeListShipping([]);
    // if (value.length >= 2) {
    //   searchIN(!value ? null : value);
    //   // setSearch(!value ? "" : value);
    //   // searchBusinessLounge(value);
    // } else {
    //   setPincodeList([]);
    // }
  };
  const handleCloneInquiryInputChange = (field, e, index) => {
    let newPersonArr = state.vendor_inquiry_value;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, vendor_inquiry_value: newPersonArr });
  };
  const handleClonegstInputChange = (field, e, index) => {
    let newPersonArr = state.suppliers_billing_details;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, suppliers_billing_details: newPersonArr });
  };
  const handleCloneShopChange = (field, e, index) => {
    let newPersonArr = state.suppliers_billing_details;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, suppliers_billing_details: newPersonArr });
  };
  const handleCloneAreaChange = (field, e, index) => {
    let newPersonArr = state.suppliers_billing_details;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, suppliers_billing_details: newPersonArr });
  };
  const setWeightSizeInquiryFieldValue = (data) => {
    console.log("data 5 ", data);
    let stateArr = [];
    let fieldObject = {};

    data.map((objectValue, objectKey) => {
      console.log("objectValue", objectValue, "objectKey", objectKey);
      stateArr.push(objectValue);
      // fieldObject["category_tree" + objectKey] = 1;
      fieldObject["company_material_type" + objectKey] =
        objectValue.company_material_type;
      fieldObject["minimum_inquiry_value" + objectKey] =
        objectValue.minimum_inquiry_value;
      fieldObject["maximum_inquiry_value" + objectKey] =
        objectValue.maximum_inquiry_value;

      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };

  const setWeightSizeAssignCityValue = (data) => {
    let stateArr = [];
    let fieldObject = {};

    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["category_tree" + objectKey] = 1;
      fieldObject["material_type" + objectKey] = objectValue.material_type;
      fieldObject["state" + objectKey] = objectValue.state;
      fieldObject["city" + objectKey] = objectValue.city;
      fieldObject["gst_number" + objectKey] = objectValue.gst_number;
      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };

  const addInquiry = () => {
    let newPersonArr = [
      ...state.vendor_inquiry_value,
      {
        company: CompanyId,
        category_tree: 1,
        minimum_inquiry_value: null,
        maximum_inquiry_value: null,
        material_type: null,
      },
    ];
    setState({ ...state, vendor_inquiry_value: newPersonArr });
    setWeightSizeInquiryFieldValue(newPersonArr);
  };

  const removeInquiry = async (lastIndex) => {
    let filterPersonArr = state.vendor_inquiry_value.filter(
      (item, index) => index !== lastIndex
    );
    setState({ ...state, vendor_inquiry_value: filterPersonArr });
    handleDisableOption(lastIndex, null); // Re-enable the removed option
    setWeightSizeInquiryFieldValue(filterPersonArr);
  };
  const handleCityChange = (values) => {
    setState({ ...state, registered_business_address_city: values });
  };

  const handleTradingCityChange = (values) => {
    setState({ ...state, trading_address_city: values });
  };

  const setWeightSizeInquiryFieldValueCity = (data) => {
    console.log("data", data);

    // Ensure data is an array
    if (!Array.isArray(data)) {
      console.error("Data is not an array:", data);
      return;
    }

    let stateArr = [];
    let fieldObject = {};

    data.forEach((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject[`category_tree${objectKey}`] = objectValue.category_tree;
      fieldObject[`material_type${objectKey}`] = objectValue.material_type;
      fieldObject[`city${objectKey}`] = objectValue.city_id;
      // fieldObject[`state${objectKey}`] = objectValue.state;
      // fieldObject[`gst_number${objectKey}`] = objectValue.gst_number;
    });

    // Log the fieldObject to debug
    console.log("fieldObject", fieldObject);

    // Ensure formRef.current exists before calling setFieldsValue
    if (formRef.current) {
      formRef.current.setFieldsValue(fieldObject);
    } else {
      console.error("formRef.current is not defined");
    }
  };
  const setWeightSizeInquiryFieldValueSuppliers = (data) => {
    console.log("data", data);

    // Ensure data is an array
    if (!Array.isArray(data)) {
      console.error("Data is not an array:", data);
      return;
    }

    let stateArr = [];
    let fieldObject = {};

    data.forEach((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject[`category_tree_${objectKey}`] = objectValue.category_tree;
      fieldObject[`gst_for_billing_${objectKey}`] = objectValue.gst_for_billing;
      fieldObject[`address_line_1_${objectKey}`] = objectValue.address_line_1;
      fieldObject[`address_line_2_${objectKey}`] = objectValue.address_line_2;
      fieldObject[`person_name_${objectKey}`] = objectValue.person_name;
      fieldObject[`landmark_${objectKey}`] = objectValue.landmark;
      fieldObject[`email_${objectKey}`] = objectValue.email;
      fieldObject[`mobile_number_${objectKey}`] = objectValue.mobile_number;
      fieldObject[`state_${objectKey}`] = objectValue.state;
      fieldObject[`city_${objectKey}`] = objectValue.city;
      fieldObject[`pincode_${objectKey}`] = objectValue.pincode;
    });

    // Log the fieldObject to debug
    console.log("fieldObject", fieldObject);

    // Ensure formRef.current exists before calling setFieldsValue
    if (formRef.current) {
      formRef.current.setFieldsValue(fieldObject);
    } else {
      console.error("formRef.current is not defined");
    }
  };
  const addInquiryCity = () => {
    const newCity = {
      company: CompanyId,
      category_tree: 1,
      material_type: null,
      city: null,
      state: null,
      gst_number: null,
    };
    setState({
      ...state,
      assign_city_to_vendor: [...state.assign_city_to_vendor, newCity],
    });
    setWeightSizeInquiryFieldValueCity(newCity);
  };

  const removeInquiryCity = (index) => {
    const updatedAssignCity = state.assign_city_to_vendor.filter(
      (_, i) => i !== index
    );
    setState({ ...state, assign_city_to_vendor: updatedAssignCity });
  };

  const handleDisableOptionCity = (index, value) => {
    console.log("index ", index, "value ", value);
    const updatedDisabledOptions = [...disabledOptionsCity]; // Make a copy of the array
    if (value !== null) {
      updatedDisabledOptions[index] = value;
    } else {
      delete updatedDisabledOptions[index];
    }
    setDisabledOptionsCity(updatedDisabledOptions);
    console.log("updatedDisabledOptions ", updatedDisabledOptions);
  };

  const handleDisableOption = (index, value) => {
    console.log("index ", index, "value ", value);
    const updatedDisabledOptions = [...disabledOptions]; // Make a copy of the array
    if (value !== null) {
      updatedDisabledOptions[index] = value;
    } else {
      delete updatedDisabledOptions[index];
    }
    setDisabledOptions(updatedDisabledOptions);
    console.log("updatedDisabledOptions ", updatedDisabledOptions);
  };

  // const searchINBilling = async (value) => {
  //   // http://127.0.0.1:8000/pincode/?search_pincode_number=38001
  //   const apiResponse = await getRequest(
  //     `pincode/?search_pincode_number=${value}`
  //   );
  //   //     setPincodeList(apiResponse.data.results.data);
  //   //   });
  //   // const apiResponse = await getRequest(
  //   //   `facility/list-facility-search/?search_on=${searchOn}&search_text=${value}`
  //   // );
  //   if (apiResponse.data.results.success) {
  //     // setPincodeList(
  //     //   apiResponse.data.results.data.map(function (el) {
  //     //     return el.pincode_number;
  //     //   })
  //     // );
  //     setPincodeListBilling(apiResponse.data.results.data);
  //     // setSuggestions(
  //     //   apiResponse.data.data.map(function (el) {
  //     //     return el.formulation_type;
  //     //   })
  //     // );
  //   }
  // };

  const handleSameAsRegisteredBusinessAddressChange = (e) => {
    const checked = e.target.checked;
    setSameAsRegisteredBusinessAddress(checked);

    if (checked) {
      setState((prevState) => {
        return {
          ...prevState,
          same_as_registered_business_address: true,
          trading_address_building:
            prevState.registered_business_address_building,
          trading_address_area: prevState.registered_business_address_area,
          trading_address_landmark:
            prevState.registered_business_address_landmark,
          trading_address_state: prevState.registered_business_address_state,
          trading_address_city: prevState.registered_business_address_city,
          trading_address_pincode:
            prevState.registered_business_address_pincode,
          trading_address_pincode_number:
            prevState.registered_business_address_pincode_number,
        };
      });
      formRef.current.setFieldsValue({
        trading_address_building: state.registered_business_address_building,
        trading_address_area: state.registered_business_address_area,
        trading_address_landmark: state.registered_business_address_landmark,
        trading_address_state: state.registered_business_address_state,
        trading_address_city: state.registered_business_address_city,
        trading_address_pincode:
          state.registered_business_address_pincode_number,
      });

      if (
        state?.registered_business_address_state !== null &&
        state?.registered_business_address_state !== undefined &&
        state?.registered_business_address_state !== ""
      ) {
        ////getCityByStateTrading(state.registered_business_address_state);
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        same_as_registered_business_address: false,
        trading_address_building: "",
        trading_address_area: "",
        trading_address_landmark: "",
        trading_address_state: "",
        trading_address_city: "",
        trading_address_pincode: "",
      }));

      formRef.current.setFieldsValue({
        trading_address_building: "",
        trading_address_area: "",
        trading_address_landmark: "",
        trading_address_state: "",
        trading_address_city: "",
        trading_address_pincode: "",
      });
    }
  };

  const items = [
    {
      key: "1",
      label: "This is panel header 1",
      children: (
        <KeyPersonVendor
          VendorId={postGeneratedVendorId}
          keypersonId={keyPersonId}
          setKeyPersonId={setKeyPersonId}
          gstVendorId={gstVendorId}
          gstValue={gstValue}
        />
      ),
    },
    {
      key: "2",
      label: "This is panel header 2",
      children: <p>{"B"}</p>,
    },
    {
      key: "3",
      label: "This is panel header 3",
      children: <p>{"C"}</p>,
    },
  ];
  const colors = ["#094E8F"];
  return (
    <>
      <Layout>
        <StepSider />
        <Content className="corecontent">
          <div className="ListingTopBar">
            <div className="pagenamewrap">
              <div className="pagename">
                {VendorId !== null ? <h3>Edit Vendor</h3> : <h3>Add Vendor</h3>}

                {/* <Breadcrumb className="Breadcrumb-Sec">
                              <Breadcrumb.Item>
                                <Link to="/dashboard">Dashboard</Link>
                              </Breadcrumb.Item>
                
                              <Breadcrumb.Item>Material Master</Breadcrumb.Item>
                            </Breadcrumb> */}
              </div>
            </div>
          </div>
          <Form
            onFinish={handleSubmit}
            autoComplete="off"
            ref={formRef}
            className="stepscontentwrap"
          >
            <div className="stepsContent">
              <div className="formwrapper" style={{ paddingRight: "5px" }}>
                <Collapse defaultActiveKey={["1"]} onChange={onChange}>
                  <Panel header="Business Info" key="1">
                    <Row gutter={16}>
                      {/* <Col
                    xs={24}
                    sm={24}
                    md={12}
                    xl={8}
                    xxl={6}
                  >
                  
                    <Form.Item
                      label={t("GST Number")}
                      // className="verifywrap"
                      name="gst_no"
                      rules={[
                        {
                          required: true,
                          message: <Trans>{t("label_gst_no")}</Trans>,
                        },
                        {
                          pattern:
                            /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                          message: t("Enter valid GST No."),
                        },
                      ]}
                    >
                      <div className="verifywrap">
                        <Input
                          placeholder={t("pl_gst_no")}
                          value={state.gst_no}
                          prefix={<IdcardOutlined />}
                          className="verifyinputfield"

                          onChange={(e) => handleGstInputChange(e.target.value)}
                          readOnly={isGstNoReadOnly}
                        />

                        {verificationResultGST !== 'success' && verificationResultGST !== 'error' && (
                          // <Button
                          //   type="primary"
                          //   className="SaveGradiantBtn verify"
                          //   loading={btnLoading}
                          //   onClick={handleGstNumberVerify}
                          // >
                          //   {t("Verify")}
                          // </Button>
                          <img
                            className="verifygstbtn"
                            loading={btnLoading}
                            onClick={handleGstNumberVerify}
                            src={verifybtn}
                            alt="Verify"
                          >
                          </img>
                        )}
                      </div>
                    </Form.Item>
                  </Col> */}

                      {/* {verificationResultGST === 'success' && (
                    <img src={verifyGST} style={{ height: '49px', marginTop: '29px' }}></img>
                    // <verifyGST className="large-icon" style={{ color: 'green' }} />
                  )}
                  {verificationResultGST === 'error' && (
                    <img src={verifyGST} style={{ height: '49px', marginTop: '29px' }}></img>
                  )} */}
                      <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                        <div className="verifywrap">
                          <InputField
                            name="gst_no"
                            label={t("place_gst_no5")}
                            placeholder={t("place_gst_no")}
                            rules={t("val_gst_no")}
                            pattern={
                              "^[0-9]{2}[A-Z]{5}[0-9]{4}" +
                              "[A-Z]{1}[1-9A-Z]{1}" +
                              "Z[0-9A-Z]{1}$"
                            }
                            prefix={<IdcardOutlined />}
                            handleInputChange={handleGstInputChange}
                          />
                          {/* {verificationResultGST !== 'success' && verificationResultGST !== 'error' && (
                          <Button
                            type="primary"
                            className="SaveGradiantBtn verify"
                            loading={btnLoading}
                            onClick={handleGstNumberVerify}
                          >
                            {t("Verify")}
                          </Button>
                        )} */}
                          {verifyGstButtonView === true ? (
                            <ButtonField
                              type="primary"
                              label={t("Verify")}
                              className="SaveGradiantBtn verify"
                              loading={btnLoadingVerifyGst}
                              onClick={handleGstNumberVerify}
                              disabled={state?.gst_no ? false : true}
                            />
                          ) : (
                            ""
                          )}

                          {verificationStatus === "success" && (
                            <img
                              src={verifybtn}
                              style={{ height: "36px", marginTop: "29px" }}
                            ></img>
                            // <verifyGST className="large-icon" style={{ color: 'green' }} />
                          )}
                          {/* {verificationStatus === "failure" && (
                    <img src={unVerify} style={{ height: '49px', marginTop: '29px' }}></img>
                  )} */}
                        </div>
                      </Col>

                      {/* <Col
                    xs={24}
                    sm={24}
                    md={12}
                    xl={8}
                    xxl={6}
                  >
                    <Form.Item
                      label={t("label_company_pan1")}
                      // className="verifywrap"
                      name="company_pan"
                      rules={[
                        {
                          required: true,
                          message: <Trans>{t("label_gst_no")}</Trans>,
                        },
                        {
                          pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                          // pattern:
                          //   /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                          message: t("Enter valid PAN No."),
                        },
                      ]}
                    >
                      <div className="verifywrap">
                        <Input
                          // name="company_pan"
                          className="verifyinputfield"
                          // label={t("label_company_pan1")}
                          placeholder={t("pl_company_pan")}
                          nonRequiredRules={t("val_company_pan")}
                          // pattern={"^[A-Z]{5}[0-9]{4}[A-Z]{1}$"}
                          prefix={<IdcardOutlined />}
                          handleInputChange={handleInputChangePancard}
                        />
                        {verificationResultPancard !== 'success' && verificationResultPancard !== 'error' && (
                          // <ButtonField
                          //   type="primary"
                          //   className="SaveGradiantBtn verify"
                          //   // htmlType="Submit"
                          //   onClick={handlePancardNumberVerify}
                          //   label={t("Verify")}
                          //   loading={btnLoadingPan}
                          // />
                          <img
                            className="verifygstbtn"
                            loading={btnLoadingPan}
                            onClick={handlePancardNumberVerify}
                            src={verifybtn}
                            alt="Verify"
                          >
                          </img>
                        )}
                      </div>
                    </Form.Item>
                  </Col>
                  {verificationResultPancard === 'success' && (
                    <img src={verifyGST} style={{ height: '49px', marginTop: '29px' }}></img>
                    // <CheckCircleOutlined className="large-icon" style={{ color: 'green' }} />
                  )}
                  {verificationResultPancard === 'error' && (
                    <img src={verifyGST} style={{ height: '49px', marginTop: '29px' }}></img>
                    // <CloseCircleOutlined className="large-icon" style={{ color: 'red' }} />
                  )} */}

                      <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                        {/* <div className="verifywrap">
                            <InputField
                              name="udyam_aadhaar_no"
                              label={t("Udyam Aadhar")}
                              placeholder={t("Enter Udyam Aadhar")}
                              rules={t("Please enter valid udyam aadhar")}
                              prefix={<IdcardOutlined />}
                              handleInputChange={handleInputChange}
                            />
                            {verificationResultAdhaar !== 'success' && verificationResultAdhaar !== 'error' && (
                              <ButtonField
                                type="primary"
                                className="SaveGradiantBtn verify"
                                // htmlType="Submit"
                                onClick={handleAdhaarNumberVerify}
                                label={t("Verify")}
                                loading={btnLoadingAdhaar}
                              />
                            )}
                            {verificationResultAdhaar === 'success' && (
                              <CheckCircleOutlined className="large-icon" style={{ color: 'green' }} />
                            )}
                            {verificationResultAdhaar === 'error' && (
                              <CloseCircleOutlined className="large-icon" style={{ color: 'red' }} />
                            )}
                          </div>
                        </Col> */}

                        <div className="verifywrap">
                          <InputField
                            name="udyam_aadhaar_no"
                            label={t("Udyam Number")}
                            placeholder={t("Enter udyam number")}
                            // pattern={"^[A-Z]{5}[0-9]{4}[A-Z]{1}$"}
                            // pattern={
                            //   "^[A-Z]{5}-[A-Z]{2}-[0-9]{2}-[0-9]{7}$"
                            // }
                            // nonRequiredRules={t("val_company_pan")}
                            // rules={t("Please enter valid udyam Number")}
                            prefix={<IdcardOutlined />}
                            handleInputChange={handleInputAdhaarChange}
                          />
                          {/* </Col> */}
                          {/* {verificationResultAdhaar !== 'success' && verificationResultAdhaar !== 'error' && (
                          <ButtonField
                            type="primary"
                            className="SaveGradiantBtn verify"
                            // htmlType="Submit"
                            onClick={handleAdhaarNumberVerify}
                            label={t("Verify")}
                            loading={btnLoadingAdhaar}
                          />
                        )}
                        {verificationResultAdhaar === 'success' && (
                          <CheckCircleOutlined className="large-icon" style={{ color: 'green' }} />
                        )}
                        {verificationResultAdhaar === 'error' && (
                          <CloseCircleOutlined className="large-icon" style={{ color: 'red' }} />
                        )} */}

                          {verifyAdhaarButtonView === true ? (
                            <ButtonField
                              type="primary"
                              className="SaveGradiantBtn verify"
                              // htmlType="Submit"
                              onClick={handleAdhaarNumberVerify}
                              label={t("Verify")}
                              loading={btnLoadingAdhaar}
                              disabled={state?.udyam_aadhaar_no ? false : true}
                            />
                          ) : (
                            ""
                          )}

                          {verificationResultAdhaar === "success" && (
                            <img
                              src={verifybtn}
                              style={{ height: "36px", marginTop: "29px" }}
                            ></img>
                            // <verifyGST className="large-icon" style={{ color: 'green' }} />
                          )}
                          {/* {verificationResultAdhaar === "failure" && (
                    <img src={unVerify} style={{ height: '36px', marginTop: '29px' }}></img>
                  )} */}

                          {/* <Form.Item

                    ><label>Company PAN Number</label>
                      <div className="verifywrap">  <Input
                        type="text"
                        placeholder="Enter Company PAN Number"
                      />
                        <Link><img

                          src={verifybtn}
                          alt="Verify"
                        ></img></Link>
                      </div>

                    </Form.Item> */}
                        </div>
                      </Col>

                      <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                        <div className="verifywrap">
                          <InputField
                            name="vendor_registered_name"
                            label={t("label_vendor_company_name")}
                            placeholder={t("pl_vendor_company_name")}
                            rules={t("val_vendor_company_name")}
                            prefix={<Vector />}
                            handleInputChange={handleInputChange}
                            max={30}
                          />
                        </div>
                      </Col>
                      <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                        <div className="verifywrap">
                          <InputField
                            placeholder="Enter vendor trade name"
                            name="vendor_trade_name"
                            label={t("Vendor Trade Name")}
                            rules={t("Please enter vendor trade name")}
                            prefix={<AddressLine />}
                            handleInputChange={handleInputChange}
                            max={50}
                          />
                        </div>
                      </Col>
                      <Col xs={24} sm={24} md={12} xl={9} xxl={7}>
                        <div className="verifywrap">
                          <InputField
                            name="vendor_code_by_company"
                            // className="BrowsButtonSec"
                            label={t("Vender Code as per Company ERP System")}
                            placeholder={t("pl_enter_vendor_code")}
                            handleInputChange={handleInputChangeVendorCode}
                            prefix={<FileAlt />}
                            // rules={t("Please enter vendor code")}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="vendorsubtitle">Contact Information</div>
                    <Row gutter={16}>
                      <Col xs={24} sm={24} md={8} xl={6} xxl={5}>
                        <InputField
                          name="person_name"
                          label={t("label_person_name")}
                          placeholder={t("pl_person_name")}
                          rules={t("val_person_name")}
                          prefix={<Name />}
                          handleInputChange={handleInputChange}
                          max={30}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8} xl={4} xxl={4}>
                        <InputField
                          name="designation"
                          label={t("label_designation")}
                          placeholder={t("pl_designation")}
                          rules={t("val_designation")}
                          prefix={<AddressLine />}
                          handleInputChange={handleInputChange}
                          max={30}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={12} xl={8} xxl={8}>
                        <div className="verifywrap">
                          <EmailField
                            name="email"
                            label={t("label_email")}
                            placeholder={t("pl_email_2")}
                            rules={t("val_email")}
                            prefix={<Email />}
                            handleInputChange={handleInputChangeEmail}
                          />
                          {verifyEmailButtonView === true ? (
                            <ButtonField
                              type="primary"
                              className="SaveGradiantBtn verify"
                              // htmlType="Submit"
                              onClick={handleEmailVerify}
                              label={t("Verify")}
                              loading={btnLoadingEmail}
                              disabled={state?.email ? false : true}
                            />
                          ) : (
                            ""
                          )}

                          {verificationResultEmail === "success" && (
                            <img
                              src={verifybtn}
                              style={{ height: "36px", marginTop: "29px" }}
                            ></img>
                          )}
                        </div>
                      </Col>
                      <Col xs={24} sm={24} md={12} xl={6} xxl={10}>
                        <div className="verifywrap">
                          <Form.Item
                            name="phone"
                            label={t("label_mobileNumber")}
                            placeholder={t("pl_mobileNumber")}
                            rules={[
                              {
                                required: true,
                                validator: validatePhoneNumber,
                                message: (
                                  <Trans> {t("val_mobileNumber")}</Trans>
                                ),
                              },
                            ]}
                          >
                            <PhoneInput
                              className="PhoneSection"
                              country={"in"}
                              value={state.phone}
                              // onChange={(phone) =>
                              //   setState({ ...state, phone: phone })
                              // }
                              onChange={handlePhoneInputChange}
                            />
                          </Form.Item>
                          {verifyPhoneButtonView === true ? (
                            <ButtonField
                              type="primary"
                              className="SaveGradiantBtn verify"
                              // htmlType="Submit"
                              onClick={handleContactNumberVerify}
                              label={t("Verify")}
                              loading={btnLoadingPhone}
                              // disabled={state?.gst_no ? verifyGstDisable : true}
                            />
                          ) : (
                            ""
                          )}

                          {verificationResultContact === "success" && (
                            <img
                              src={verifybtn}
                              style={{ height: "36px", marginTop: "29px" }}
                            ></img>
                            // <verifyGST className="large-icon" style={{ color: 'green' }} />
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Row gutter={32}>
                      <Col xs={24} xl={12} className="bdr">
                        <div className="colwrap">
                          <div className="colsubtitle">
                            Registered Business Address
                          </div>
                          <Row gutter={16}>
                            <Col xs={24} md={12}>
                              <Form.Item
                                name="registered_business_address_building"
                                label={t("Shop No., Building, Apartment")}
                                rules={[
                                  {
                                    required: true,
                                    message: t(
                                      "Please enter shop no., building, company, apartment"
                                    ),
                                  },
                                ]}
                              >
                                <Input
                                  placeholder={t(
                                    "Enter shop no., building, apartment"
                                  )}
                                  maxLength={50}
                                  value={
                                    state.registered_business_address_building
                                  }
                                  onChange={(e) =>
                                    handleChange(
                                      "registered_business_address_building",
                                      e.target.value
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                              <Form.Item
                                name="registered_business_address_area"
                                label={t("Area, Street")}
                                rules={[
                                  {
                                    required: true,
                                    message: t("Please enter Area, Street"),
                                  },
                                ]}
                              >
                                <Input
                                  placeholder={t("Enter area, street")}
                                  maxLength={50}
                                  value={state.registered_business_address_area}
                                  onChange={(e) =>
                                    handleChange(
                                      "registered_business_address_area",
                                      e.target.value
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                              <Form.Item
                                name="registered_business_address_landmark"
                                label={t("Landmark")}
                                rules={[
                                  {
                                    required: true,
                                    message: t("Please enter landmark"),
                                  },
                                ]}
                              >
                                <Input
                                  placeholder={t("Enter landmark")}
                                  maxLength={50}
                                  value={
                                    state.registered_business_address_landmark
                                  }
                                  onChange={(e) =>
                                    handleChange(
                                      "registered_business_address_landmark",
                                      e.target.value
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                              <Form.Item
                                name="registered_business_address_pincode"
                                label={t("pl_pincode")}
                                prefix={<ZipCode />}
                                rules={[
                                  {
                                    required: true,
                                    message: (
                                      <Trans>{t("val_postal_zip_code")}</Trans>
                                    ),
                                  },
                                ]}
                              >
                                {/* <AutoComplete
                                className="autoComplete"
                                onSelect={onSelectShipping}
                                onSearch={onSearchShipping}
                                value={searchValueBilling}
                                optionFilterProp="children"
                                allowClear
                                placeholder={t("pl_pincodeselect")}
                                onChange={(value) =>
                                  handlePincodeBillingChange(
                                    "registered_business_address_pincode",
                                    value
                                  )
                                }
                              >
                                {pincodeListShipping.map((option) => (
                                  <Option
                                    key={option.id}
                                    value={option.pincode_number}
                                  >
                                    {option.pincode_number}
                                  </Option>
                                ))}
                              </AutoComplete> */}

                                <AutoComplete
                                  className="autoComplete"
                                  //onSelect={onSelectBilling}
                                  onSearch={onSearchBillingResgistered}
                                  value={
                                    state.registered_business_address_pincode
                                  }
                                  optionFilterProp="children"
                                  allowClear
                                  placeholder={t("pl_pincodeselect")}
                                  onChange={handlePincodeBillingChange}
                                >
                                  {pincodeListBillingRegistered.map(
                                    (option) => (
                                      <Option
                                        key={option.id}
                                        value={option.pincode_number}
                                      >
                                        {option.pincode_number}
                                      </Option>
                                    )
                                  )}
                                </AutoComplete>
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                              <Form.Item
                                name="registered_business_address_city"
                                label={t("pl_city")}
                                // value={state.billing_city}
                                rules={[
                                  {
                                    required: true,
                                    message: <Trans>{t("val_city")}</Trans>,
                                  },
                                ]}
                              >
                                {/* <Select
                              showArrow
                              showSearch
                              optionFilterProp="children"
                              placeholder={t("place_city")}
                              // onChange={(value) => handleRoleSelectChange(value)}
                              onChange={(value) => handleCityChange(value)}
                              //onChange={handleCityChange}
                              prefix={<ZipCode />}
                            >
                              {cityDropdownOptionsShipping.map((item) => (
                                <Select.Option key={item.id} value={item.id}>
                                  {item.name}
                                </Select.Option>
                              ))}
                            </Select> */}
                                <Input
                                  placeholder={t("place_city")}
                                  value={state.registered_business_address_city}
                                  disabled
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                              <Form.Item
                                name="registered_business_address_state"
                                label={t("pl_state_province")}
                                value={state.registered_business_address_state}
                                // prefix={<User />}
                                rules={[
                                  {
                                    required: true,
                                    message: (
                                      <Trans>{t("val_state_province")}</Trans>
                                    ),
                                  },
                                ]}
                              >
                                {/* <Select
                                showArrow
                                showSearch
                                placeholder={t("place_state")}
                                onChange={(value) =>
                                  handleStateChangeRegistered(value)
                                }
                                optionFilterProp="children"
                                // onChange={handleStateChangeShipping}
                                prefix={<ZipCode />}
                              >
                                {stateDropdownOptionsShipping.map((item) => (
                                  <Option key={item.id} value={item.id}>
                                    {item.name}
                                  </Option>
                                ))}
                              </Select> */}
                                <Input
                                  value={
                                    state.registered_business_address_state
                                  }
                                  placeholder={t("place_state")}
                                  disabled
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                      <Col xs={24} xl={12}>
                        <div className="colwrap">
                          <div className="colsubtitle">
                            Trading Address
                            {/* <Checkbox>
                        Same as my Business Address
                      </Checkbox> */}
                            <Tooltip
                              title="Same as registered business address"
                              name="same_as_registered_business_address"
                            >
                              <Checkbox
                                style={{ marginLeft: "10px" }}
                                checked={sameAsRegisteredBusinessAddress}
                                onChange={(e) =>
                                  handleSameAsRegisteredBusinessAddressChange(e)
                                }
                              >
                                Same as my business address
                              </Checkbox>
                            </Tooltip>
                          </div>
                          <Row gutter={16}>
                            <Col xs={24} md={12}>
                              <Form.Item
                                name="trading_address_building"
                                label={t("Shop No., Building, Apartment")}
                                rules={[
                                  {
                                    required: true,
                                    message: t(
                                      "Please enter shop No., building, apartment"
                                    ),
                                  },
                                ]}
                              >
                                <Input
                                  placeholder={t(
                                    "Enter shop no., building, company, apartment"
                                  )}
                                  maxLength={50}
                                  value={state.trading_address_building}
                                  onChange={(e) =>
                                    handleChange(
                                      "trading_address_building",
                                      e.target.value
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                              <Form.Item
                                name="trading_address_area"
                                label={t("Area, Street")}
                                rules={[
                                  {
                                    required: true,
                                    message: t("Please enter Area, Street"),
                                  },
                                ]}
                              >
                                <Input
                                  placeholder={t("Enter area, street")}
                                  maxLength={50}
                                  value={state.trading_address_area}
                                  onChange={(e) =>
                                    handleChange(
                                      "trading_address_area",
                                      e.target.value
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                              <Form.Item
                                name="trading_address_landmark"
                                label={t("Landmark")}
                                rules={[
                                  {
                                    required: true,
                                    message: t("Please enter landmark"),
                                  },
                                ]}
                              >
                                <Input
                                  placeholder={t("Enter landmark")}
                                  maxLength={50}
                                  value={state.trading_address_landmark}
                                  onChange={(e) =>
                                    handleChange(
                                      "trading_address_landmark",
                                      e.target.value
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                              <Form.Item
                                name="trading_address_pincode"
                                label={t("pl_pincode")}
                                prefix={<ZipCode />}
                                rules={[
                                  {
                                    required: true,
                                    message: (
                                      <Trans>{t("val_postal_zip_code")}</Trans>
                                    ),
                                  },
                                ]}
                              >
                                {/* <AutoComplete
                                className="autoComplete"
                                onSelect={onSelectBilling}
                                onSearch={onSearchBilling}
                                value={searchValueBilling}
                                optionFilterProp="children"
                                allowClear
                                placeholder={t("pl_pincodeselect")}
                                onChange={(value) =>
                                  handlePincodeBillingChange(
                                    "trading_address_pincode",
                                    value
                                  )
                                }
                              >
                                {pincodeListBillingTranding.map((option) => (
                                  <Option
                                    key={option.id}
                                    value={option.pincode_number}
                                  >
                                    {option.pincode_number}
                                  </Option>
                                ))}
                              </AutoComplete> */}
                                <AutoComplete
                                  className="autoComplete"
                                  // onSelect={onSelectShipping}
                                  onSearch={onSearchShippingTrading}
                                  value={state.trading_address_pincode}
                                  optionFilterProp="children"
                                  allowClear
                                  placeholder={t("pl_pincodeselect")}
                                  onChange={handlePincodeShippingTradingChange}
                                >
                                  {pincodeListShippingtrading.map((option) => (
                                    <Option
                                      key={option.id}
                                      value={option.pincode_number}
                                    >
                                      {option.pincode_number}
                                    </Option>
                                  ))}
                                </AutoComplete>
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                              <Form.Item
                                name="trading_address_city"
                                label={t("pl_city")}
                                // value={state.billing_city}
                                rules={[
                                  {
                                    required: true,
                                    message: <Trans>{t("val_city")}</Trans>,
                                  },
                                ]}
                              >
                                <Input
                                  placeholder={t("place_city")}
                                  value={state.trading_address_city}
                                  disabled
                                />
                                {/* <Select
                                showArrow
                                showSearch
                                optionFilterProp="children"
                                placeholder={t("place_city")}
                                // onChange={(value) => handleRoleSelectChange(value)}
                                // onChange={(value) =>
                                //   handleChange("billing_city", value)
                                // }
                                onChange={handleTradingCityChange}
                                prefix={<ZipCode />}
                              >
                                {tradingCityDropdownOptions.map((item) => (
                                  <Select.Option key={item.id} value={item.id}>
                                    {item.name}
                                  </Select.Option>
                                ))}
                              </Select> */}
                              </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                              <Form.Item
                                name="trading_address_state"
                                label={t("pl_state_province")}
                                value={state.trading_address_state}
                                // prefix={<User />}
                                rules={[
                                  {
                                    required: true,
                                    message: (
                                      <Trans>{t("val_state_province")}</Trans>
                                    ),
                                  },
                                ]}
                              >
                                <Input
                                  placeholder={t("place_state")}
                                  value={state.trading_address_state}
                                  disabled
                                />
                                {/* <Select
                                showArrow
                                showSearch
                                optionFilterProp="children"
                                placeholder={t("place_state")}
                                // onChange={(value) =>
                                //   handleChange("shipping_state", value)
                                // }
                                onChange={handleStateChangeTrading}
                                prefix={<ZipCode />}
                              >
                                {stateDropdownOptionsShipping.map((item) => (
                                  <Option key={item.id} value={item.id}>
                                    {item.name}
                                  </Option>
                                ))}
                              </Select> */}
                              </Form.Item>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>

                    <StepInquiryValueVendor
                      state={state}
                      setState={setState}
                      CompanyId={CompanyId}
                      categoryTree={categoryTree}
                    />

                    <div className="subbuttonsrow">
                      <Button
                        cursor="pointer"
                        className="primary"
                        icon={<SaveOutlined />}
                        loading={btnLoading}
                        // className="SaveGradiantBtn"
                        type="primary"
                        htmlType="submit"
                        label="Save"
                      >
                        Save
                      </Button>
                    </div>
                  </Panel>

                  {/* <Panel header="Bank Details" key="3"> */}
                  <Collapse>
                    <Panel
                      header="Key Person"
                      key="7"
                      disabled={!showKeyPersonCollapse}
                    >
                      <Row gutter={16}>
                        <Collapse style={{ width: "100%" }}>
                          <KeyPersonVendor
                            VendorId={postGeneratedVendorId}
                            keypersonId={keyPersonId}
                            setKeyPersonId={setKeyPersonId}
                            gstVendorId={gstVendorId}
                            gstValue={gstValue}
                            //showBankDetailsCollapse={showBankDetailsCollapse}
                            // setShowBankDetailsCollapse={
                            //   setShowBankDetailsCollapse
                            // }
                            setShowVendorBillingDetails={
                              setShowVendorBillingDetails
                            }
                          />
                        </Collapse>
                      </Row>
                    </Panel>
                  </Collapse>
                  <Panel
                    header="Vendor Billing Details"
                    key="3"
                    disabled={!showVendorBillingDetails}
                  >
                    <Row gutter={16}>
                      <Collapse>
                        {/* <SupplierBillingDetails
                            VendorId={postGeneratedVendorId}
                            supplierBillingId={supplierBillingId}
                            SetSupplierBillingId={SetSupplierBillingId}
                            gstVendorId={gstVendorId}
                            gstValue={gstValue}
                            CompanyId={CompanyId}
                          />
                        </Collapse>
                      </Row>
                    </Panel> */}
                        <SupplierBillingDetails
                          VendorId={postGeneratedVendorId}
                          supplierBillingId={supplierBillingId}
                          SetSupplierBillingId={SetSupplierBillingId}
                          gstVendorId={gstVendorId}
                          gstValue={gstValue}
                          CompanyId={CompanyId}
                          setShowBankDetailsCollapse={
                            setShowBankDetailsCollapse
                          }
                        />
                      </Collapse>
                    </Row>
                  </Panel>
                  <Panel
                    header="Bank Details"
                    key="4"
                    disabled={!showBankDetailsCollapse}
                  >
                    <Collapse>
                      <BankDetailsVendor
                        VendorId={postGeneratedVendorId}
                        bankdetailId={bankDetailId}
                        setBankDetailId={setBankDetailId}
                        gstVendorId={gstVendorId}
                        gstValue={gstValue}
                        CompanyId={CompanyId}
                        setShowPaymentCollapse={setShowPaymentCollapse}
                      />
                    </Collapse>

                    {/* <div className="subbuttonsrow">
                    <Button
                      cursor="pointer"
                      type="primary"
                      className="primary"
                      icon={<SaveOutlined />}
                    >
                      Save
                    </Button>
                  </div> */}
                  </Panel>
                  <Collapse>
                    <Panel
                      header="Payment Terms"
                      key="5"
                      disabled={!showPaymentCollapse}
                    >
                      <PaymentVendor
                        VendorId={postGeneratedVendorId}
                        paymenttermsId={paymentTermsId}
                        setPaymentTermsId={setPaymentTermsId}
                        setShowPaymentPersonReleasedField={
                          setShowPaymentPersonReleasedField
                        }
                        gstVendorId={gstVendorId}
                        gstValue={gstValue}
                      />
                    </Panel>
                  </Collapse>
                  {/* <Panel header="Payment" key="4">
                  <Row gutter={16}>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      xl={8}
                      xxl={6}
                    >
                      <Form.Item

                      ><label>Days To Pay</label>
                        <Select
                          defaultValue="MT"
                          placeholder="Select Days To Pay"

                          allowClear
                          options={[
                            {
                              value: 'MT',
                              label: 'Mt',
                            },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      xl={8}
                      xxl={6}
                    >
                      <Form.Item

                      ><label>When To Pay</label>
                        <Select
                          defaultValue="MT"
                          placeholder="Select When To Pay"

                          allowClear
                          options={[
                            {
                              value: 'MT',
                              label: 'Mt',
                            },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      xl={8}
                      xxl={6}
                    >
                      <Form.Item

                      ><label>From When To Calculate</label>
                        <Select
                          defaultValue="MT"
                          placeholder="Select From When To Calculate"

                          allowClear
                          options={[
                            {
                              value: 'MT',
                              label: 'Mt',
                            },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      xl={8}
                      xxl={6}
                    >
                      <Form.Item

                      ><label>Advance in %</label>
                        <Input
                          type="text"
                          placeholder="% 0"
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      xl={8}
                      xxl={6}
                    >
                      <Form.Item

                      ><label>Select payment security type</label>
                        <Select
                          defaultValue="MT"
                          placeholder="Select payment security type"

                          allowClear
                          options={[
                            {
                              value: 'MT',
                              label: 'Mt',
                            },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      xl={8}
                      xxl={6}
                    >
                      <Form.Item

                      ><label>Other Payment Security Type</label>
                        <Input
                          type="text"
                          placeholder="Enter Other Payment Security Type"
                        />
                      </Form.Item>
                    </Col>

                  </Row>
                  <div className="subbuttonsrow">
                    <Button
                      cursor="pointer"
                      type="primary"
                      className="primary"
                      icon={<SaveOutlined />}
                    >
                      Save
                    </Button>
                  </div>
                </Panel> */}
                  {/* <Panel header="Whom To Intimate When Payment Is Released" key="5">
                  <Row gutter={16}>

                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      xl={6}
                      xxl={4}
                    >
                      <Form.Item

                      ><label>Person Name</label>
                        <Input
                          type="text"
                          placeholder="Enter Person Name"
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      xl={6}
                      xxl={4}
                    >
                      <Form.Item

                      ><label>Designation</label>
                        <Input
                          type="text"
                          placeholder="Enter Designation"
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      xl={6}
                      xxl={4}
                    >
                      <Form.Item

                      ><label>Department</label>
                        <Input
                          type="text"
                          placeholder="Enter Department"
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      xl={6}
                      xxl={4}
                    >
                      <Form.Item

                      ><label>Email</label>
                        <Input
                          type="text"
                          placeholder="Enter Email"
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      xl={6}
                      xxl={4}
                    >
                      <Form.Item

                      ><label>Contact Number</label>
                        <div className="phonefield">
                          <PhoneInput
                            country={"in"}
                            className="PhoneSection"

                          />
                        </div>
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      xl={4}
                      xxl={4}
                    >
                      <div className="addwrp">
                        <Space>
                          <PlusSquareFilled
                            className="add"
                          />
                        </Space>
                      </div>
                    </Col>
                  </Row>
                  <div className="subbuttonsrow">
                    <Button
                      cursor="pointer"
                      type="primary"
                      className="primary"
                      icon={<SaveOutlined />}
                    >
                      Save
                    </Button>
                  </div>
                </Panel>
                <Collapse> */}
                  <Panel
                    header="Whom To Intimate When Payment Is Released"
                    key="6"
                    //disabled={!showPaymentPersonReleasedField}
                  >
                    <PaymentPersonReleasedField
                      VendorId={postGeneratedVendorId}
                      paymentReleasedId={paymentReleasedId}
                      setPaymentReleasedId={setPaymentReleasedId}
                      gstVendorId={gstVendorId}
                      gstValue={gstValue}
                      CompanyId={CompanyId}
                    />
                  </Panel>
                  {/* </Collapse> */}
                  {/* <Panel header="Vendor Communication Matrix" key="6">
                <Row gutter={16}>

                  <Col
                    xs={24}
                    sm={12}
                    md={8}
                    xl={6}
                    xxl={4}
                  >
                    <Form.Item

                    ><label>Email</label>
                      <Input
                        type="text"
                        placeholder="Enter Email"
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={12}
                    md={8}
                    xl={6}
                    xxl={4}
                  >
                    <Form.Item

                    ><label>Person Name</label>
                      <Input
                        type="text"
                        placeholder="Enter Person Name"
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={12}
                    md={8}
                    xl={6}
                    xxl={4}
                  >
                    <Form.Item

                    ><label>Enter Designation</label>
                      <Input
                        type="text"
                        placeholder="Enter Designation"
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={12}
                    md={8}
                    xl={6}
                    xxl={4}
                  >
                    <Form.Item

                    ><label>Contact Number</label>
                      <div className="phonefield">
                        <PhoneInput
                          country={"in"}
                          className="PhoneSection"

                        />
                      </div>
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={12}
                    md={8}
                    xl={6}
                    xxl={4}
                  >
                    <Form.Item

                    ><label>Communication Step</label>
                      <Select
                        defaultValue="MT"
                        placeholder="Select Communication Step"

                        allowClear
                        options={[
                          {
                            value: 'MT',
                            label: 'Mt',
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={12}
                    md={8}
                    xl={4}
                    xxl={4}
                  >
                    <div className="addwrp">
                      <Space>
                        <PlusSquareFilled
                          className="add"
                        />
                      </Space>
                    </div>
                  </Col>
                </Row>
                <div className="subbuttonsrow">
                  <Button
                    cursor="pointer"
                    type="primary"
                    className="primary"
                    icon={<SaveOutlined />}
                  >
                    Save
                  </Button>
                </div>
              </Panel> */}
                  <Collapse>
                    <Panel
                      header="Vendor Communication Matrix"
                      key="7"
                      disabled={!showVendorCommunicationCollapse}
                    >
                      <CommunicationMatrixVendor
                        VendorId={postGeneratedVendorId}
                        communicationMatrixId={communicationMatrixId}
                        setCommunicationMatrixId={setCommunicationMatrixId}
                        gstVendorId={gstVendorId}
                        gstValue={gstValue}
                      />
                    </Panel>
                  </Collapse>

                  <Collapse>
                    <Panel
                      header="Vendor Document"
                      key="8"
                      disabled={!showVendorCommunicationCollapse}
                    >
                      <VendorDocumentFieldStep
                        VendorId={postGeneratedVendorId}
                        // communicationMatrixId={communicationMatrixId}
                        // setCommunicationMatrixId={setCommunicationMatrixId}
                        gstVendorId={gstVendorId}
                        gstValue={gstValue}
                      />
                    </Panel>
                  </Collapse>
                </Collapse>
              </div>
            </div>
            <div className="stepsFooter">
              <Button
                cursor="pointer"
                type="secondary"
                className="primary"
                onClick={() => navigate("/vendor-onboarding-step")}
              >
                Previous
              </Button>
              {/* <Button
            cursor="pointer"
            type="primary"
            className="primary"
          >
            Go To Dashboard
          </Button> */}
            </div>
          </Form>
          <Modal
            className="ModelPopupSec"
            title={"Verify Email"}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            closable={handleCancel}
            wrapClassName="modal-wrapper"
            keyboard={false}
          >
            {/* <Tabs defaultActiveKey="1" items={items} onChange={onChange} /> */}
            <VerifyOtpModal
              // zoneList={zoneList}
              handleCancel={handleCancel}
              setVerifyEmailButtonView={setVerifyEmailButtonView}
              OTP={OTP}
              setOTP={setOTP}
              state={state}
              setState={setState}
              setMinutes={setMinutes}
              setSeconds={setSeconds}
              seconds={seconds}
              minutes={minutes}
              handleSendOtpEmail={handleSendOtpEmail}
              setVerificationResultEmail={setVerificationResultEmail}
              // reload={reload}
              // setReload={setReload}
              // handleCancel={handleCancel}
              // pincodeId={pincodeId}
              // modalKey={modalKey}
              // setStateM = {setState}
            />
          </Modal>
          <Modal
            className="ModelPopupSec"
            title={"Verify Mobile"}
            open={isModalOpenPhone}
            onOk={handleOkPhone}
            onCancel={handleCancelPhone}
            closable={handleCancelPhone}
            wrapClassName="modal-wrapper"
            keyboard={false}
          >
            {/* <Tabs defaultActiveKey="1" items={items} onChange={onChange} /> */}
            <PhoneOtpVerify
              // zoneList={zoneList}
              handleCancelPhone={handleCancelPhone}
              setVerifyPhoneButtonView={setVerifyPhoneButtonView}
              OTP={OTPPhone}
              setOTP={setOTPPhone}
              state={state}
              setState={setState}
              setMinutes={setMinutesPhone}
              setSeconds={setSecondsPhone}
              seconds={secondsPhone}
              minutes={minutesPhone}
              handleSendOtpPhone={handleSendOtpPhone}
              setVerificationResultContact={setVerificationResultContact}
              // reload={reload}
              // setReload={setReload}
              // handleCancel={handleCancel}
              // pincodeId={pincodeId}
              // modalKey={modalKey}
              // setStateM = {setState}
              // mode={"email"}
            />
          </Modal>
        </Content>
      </Layout>
    </>
  );
};

export default AddVendorOnboardingStep;
